/**
 * Plugin
 */
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, Renderer, ViewChild } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';
import { Camera } from '@ionic-native/camera';
import { Diagnostic } from '@ionic-native/diagnostic';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import 'hammerjs';
import {
  ActionSheetController,
  AlertController,
  App,
  Content,
  Events,
  FabContainer,
  InfiniteScroll,
  IonicPage,
  LoadingController,
  MenuController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  PopoverController,
  Slides,
  ToastController,
  ViewController
} from 'ionic-angular';
import moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { expandVertical } from '../../../animations/appear-animation';
import { AuthenticationBloc } from '../../../bloc/authentication/authentication.bloc';
import { InitializeBloc } from '../../../bloc/authentication/initialize.bloc';
import { MultipleAccountBloc, SwitchAccountResponse } from '../../../bloc/authentication/multiple-account.bloc';
import { CompanySetUpBloc } from '../../../bloc/company/company-setup.bloc';
import { CompanyBloc } from '../../../bloc/company/company.bloc';
import { BackgroundGeolocationBloc } from '../../../bloc/feature/background-geolocation/background-geolocation.bloc';
import { CompanyMoodBloc } from '../../../bloc/feature/company-mood/company-mood.bloc';
import { HomeBloc } from '../../../bloc/feature/home/home.bloc';
import { addPostingParams } from '../../../bloc/feature/home/home.dto';
import { OnBoardingBloc } from '../../../bloc/feature/on-boarding/on-boarding.bloc';
import { AttendanceBloc } from '../../../bloc/hr/attendance/attendance.bloc';
import { EventLabel } from '../../../helpers/event-label';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';
import { Messages } from '../../../helpers/messages';
import RootPage from '../../../helpers/root-page.helper';
import { AttendancePreviewData } from '../../../model/attendance/attendance-preview.model';
import { GDAuthInterface } from '../../../model/gd-auth';
import { GDStorageInterface, StoredPrelogin } from '../../../model/gd-storage';
import { OptionUpdateUserIntercom } from '../../../model/intercome.model';
import { Paginate } from '../../../model/paginate';
import { Personal } from '../../../model/personal';
import { PageBuilderGlobal } from '../../../pagebuilder/providers/global';
import { MenuProvider } from '../../../pagebuilder/services/menu/menu';
import { PageBuilderMenuProvider } from '../../../pagebuilder/services/menu/repository';
import { PageBuilderFeaturePageProvider } from '../../../pagebuilder/services/schema/feature-page-service';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { AppGuideProviders } from '../../../providers/app-guide/appGuideProviders';
import { ChatServiceProvider } from '../../../providers/chat-service/chat-service';
import { CustomPluginProvider } from '../../../providers/custom-plugin/custom-plugin';
import { GamificationProvider } from '../../../providers/gamification/gamification';
import { ChatSupportService } from '../../../providers/chat-support/chat-support-service';
import { IntroProvider } from '../../../providers/intro/intro';
import { LoadingServiceProvider } from '../../../providers/loading-service/loading-service';
import { HomeFeedStateProvider } from '../../../providers/management-state/homefeed.state';
import { NavigationService } from '../../../providers/navigation/navigation';
import { PermissionCheckProvider } from '../../../providers/permission-check/permission-check';
import { SFGOAuthService } from '../../../providers/sfgoauth.service/sfgoauth.service';
import { SocketIoClientProvider } from '../../../providers/socket-io-client/socket-io-client';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { ToastServiceProvider } from '../../../providers/toast-service/toast.service';
import { AppPreferences, Preference } from '../../../shared/local/app-preferences.local';
import { AnnouncementProvider } from '../../../shared/nestjs/announcement/announcement';
import { RequestInboxApi } from '../../../shared/nestjs/gd-all-in-one/services/request-inbox.api';
import { SF6SPolicyApi } from '../../../shared/nestjs/gd-integrated/services/sf6s-policy.api';
import { RequestGetFeedDto } from '../../../shared/nestjs/gd-only/dto/feed-service.dto';
import { badgeModule } from '../../../shared/nestjs/gd-only/dto/gamification.dto';
import { AuthApi } from '../../../shared/nestjs/gd-only/services/auth.api';
import { FeedServiceNestApi } from '../../../shared/nestjs/gd-only/services/feed-service.api';
import { PersonalNestApi } from '../../../shared/nestjs/gd-only/services/personal.api';
import { HomeFeedProvider } from '../../../shared/nestjs/home-feed/home-feed';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { NestAuthProvider } from '../../../shared/nestjs/nest-auth';
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import { YesdokService } from '../../../shared/nestjs/yesdok/yesdok.api';
import {
  BuilderServiceApi,
  LeaderBoardApi,
  PaydayLoanServiceApi,
  PostServiceApi,
  SettingServiceApi,
  SfRequestApi,
  YesdokserviceApi
} from '../../../shared/sdk';
import { PersonalApi } from '../../../shared/sdk/services/custom/Personal';
import { SubscriptionServiceApi } from '../../../shared/sdk/services/custom/SubscriptionService';
import { PollingBloc } from './../../../bloc/feature/polling/polling.bloc';
import { PageBuilderVersionProvider } from './../../../pagebuilder/services/version/version-service';
import { AnalyticsProvider } from './../../../providers/analytics/analytics';
/**
 * provider
 */
import { GlobalServiceProvider } from './../../../providers/global-service/global-service';
import { SaasProvider } from './../../../providers/saas/saas';
import { LoopBackAuth } from './../../../shared/sdk/services/core/auth.service';
import { RealTime } from './../../../shared/sdk/services/core/real.time';
import { AccessmanagementApi } from './../../../shared/sdk/services/custom/Accessmanagement';
import { FeedServiceApi } from './../../../shared/sdk/services/custom/FeedService';
import { RegistrationNewApi } from './../../../shared/sdk/services/custom/RegistrationNew';
import { SFAttendanceApi } from './../../../shared/sdk/services/custom/SFAttendance';
import { SFPolicyApi } from './../../../shared/sdk/services/custom/SFPolicy';
import { SunfishApi } from './../../../shared/sdk/services/custom/Sunfish';
/**
 * SDK
 */
import { TsfeedserviceApi } from './../../../shared/sdk/services/custom/Tsfeedservice';
import { TspostserviceApi } from './../../../shared/sdk/services/custom/Tspostservice';
import { GdTeammatesPage } from './gd-teammates/gd-teammates';
import { AttendanceRedirectPage } from '../../../shared/nestjs/gd-only/dto/attendance.dto';
import { WorklocationServiceProvider } from '../../../providers/worklocation/worklocation.service';
@IonicPage()
@Component({
  selector: 'page-home2',
  templateUrl: 'home2.html',
  animations: [
    trigger('animateTaskOption', [
      transition(':enter', [
        style({ opacity: 0, width: 0, transform: 'translateY(10px)' }),
        animate('120ms cubic-bezier(0.455, 0.03, 0.515, 0.955)', style({ opacity: 0, width: 0, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('120ms cubic-bezier(0.455, 0.03, 0.515, 0.955)', style({ opacity: 0, width: 0, transform: 'translateY(24px)' }))
      ])
    ]),
    trigger('animateBanner', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms ease', style({ opacity: 0 })),
      ]),
      transition(':leave', [
        animate('100ms ease', style({ opacity: 0 }))
      ])
    ]),
    expandVertical
  ]
})
export class Home2Page implements AfterViewInit, OnInit {

  @ViewChild('homeHeader') homeHeader: ElementRef;
  @ViewChild(Content) content: Content;
  @ViewChild(Slides) slides: Slides;
  @ViewChild('moreFeed') moreFeed: ElementRef;
  @ViewChild('addpost') addpost: ElementRef;
  @ViewChild('leftSidebar') leftSidebar: ElementRef;
  @ViewChild('leftSpacer') leftSpacer: ElementRef;
  @ViewChild('fileInput') fileInput;
  @ViewChild('teammates') teammatesComponent: GdTeammatesPage;
  @ViewChild('holderArea') holderArea: ElementRef;
  @ViewChild('modalArea') modalArea: ElementRef;
  @ViewChild('notificationBox') notificationBox: ElementRef;

  public overlayHidden = false;
  public subscriptions: Array<Subscription> = [];
  public fab: FabContainer;
  public SFGoAuth: GDAuthInterface;
  public getStart1 = true;
  public getStart2 = true;
  public getStart3 = true;
  public overlayStarted = false;

  /** Variable Standart */
  public scrollTopPx: boolean = false;
  public beforeScrollPx: number;
  public afterScrollPx: number;
  public empphotopath: any;
  public dataFeed: Array<any> = [];
  public dummyDataFeed: any[];
  public slideView: number;
  public paramsDate: any;
  public postEmpty: any;
  public tab: any = 'INBOX';
  public filter: any = { type: 'ALL', status: 'INBOX' };
  public isLoad = false;
  public isRequest = false;
  public loadingRun: any = {
    request: false,
    post: false,
    alert: false,
    chats: false,
    inbox: false,
    important: false,
    archived: false
  };
  public onload: boolean = true;

  /** Default */
  public limit: any = 15;
  public skip: any = 0;

  /** Dinamic */
  public skipDinamic: any = 0;
  public infiniteFinish: any = false;
  public totalNewPost: any = 0;
  public dataFollowing: any = [];
  public reqinboxcount: any = 0;

  /* scroll interaction */
  public boolChangeClass: boolean = false;
  public pixel: any = 0;
  public tScroll: number = 0;
  public tCol: any = 0;
  public tHead: any;
  public dataY: number = 0;
  public dataX: number;
  public headerHd: boolean = false;

  /* NEW scroll interaction */
  public aPwidth: any;
  public moreFixed: boolean = false;
  public postFxWidth: any;
  public aPmaXwidth: any;
  public infiniteLoading: boolean = false;
  public InfiniteLoader: any;

  /** No post Feature */
  showMenuMobile: any = 225;
  hideMenuMobile: any = 110;
  /** No post Feature */
  nopost: any = 62;
  noposthead: any = 98;
  // #region: Sticky column scroll
  public headerHeight;
  public scrollY: number = 0;
  public start2show: boolean = false;
  public showLimit: number = 162;
  public lastScrollY: number = 0;
  public scrollDir;
  public leftPreSpace: number;
  public spacerOffsetTop;
  public leftSidebarTop;
  public leftSidebarBottom;
  public leftSidebarPosition;
  public wasScrollDown;
  // #endregion

  public isISS: any = false;
  public isLoadingHome: boolean = false;
  public pages: Array<{ title: string, component: any, icon: any, show: boolean }>;
  public showRequest = true;
  public isSF6 = false;
  public empId: any;
  public isHR = false;
  public isSpv = false;
  public dataEmp: any;
  public flagCompProfile: false;
  public flagCompDetail: false;
  public flagEmp: false;
  public statusUser: any = "";
  public companyName: any;
  public companyCode: any;
  public dataIntro: any = [];
  public showIntro: boolean = true;
  public classSlider: any = "slide-onboard-single";
  public socialMedia: any = true;
  public bannerSurvey: any = false;
  public tasknFeedBack: any = false;
  public tasknFeedBackButtonAdd: any = false;
  public isSpinner: boolean;
  public myDate: any;
  public clockIn: any = null;
  public clockOut: any = null;
  public actualClockIn: any = null;
  public actualClockOut: any = null;
  public feedBack: any;
  public showRatingCount: any = 1;
  public menuCount: any = 0;
  public activeBannerIndex: any = 0;
  public isFix: boolean;
  public currentTask: any;

  public requestBadge: any = {
    request: 0,
    approval: 0
  }

  public languageSelected: any = "en";
  public isRecordTime: boolean = false;
  public isSwitchComp: boolean = false;

  // define setting attendance
  public takePhoto: any = 1; // 1 = true
  public isScroll = false;
  public userId: any;
  public photoProfile: any;
  public name: any;
  public position: any;
  public taxCountry: any;

  // GET A WINDOWS SIZE
  public tabletSize: any = 768;
  public tabletProSize: any = 960;
  public windowXsize: any;
  public windowYsize: any;
  public isMobile: boolean = true;
  public isTablet: boolean = false;
  public isWrapping: boolean = false;
  public isUnwrap: boolean = false;

  // Menu apps
  public menuToggle: boolean = false;
  public dummyMenu: any = [];
  public decrease: any;
  public lastPosX: number = 0;
  public lastPosY: number = 0;
  public closeNotif: boolean = false;

  // Gesture Hammer
  public holder: any;
  public panDown: any;
  public modalWrapper: any;
  public isOpen: boolean = false;
  public isDragging: boolean = false;
  public isSwipeDown: boolean = false;
  public lastDeltaY: any;
  public posYExp: any;
  public isShowMenu: boolean = false;

  // Add post offset
  public topPost: any;
  public leftPost: any;
  public widthPost: any;

  public isDisabled: boolean = false;
  public isDisabledSubject: Subject<boolean> = new Subject<boolean>();
  public showNotif: boolean = false; // hardcoded notif for #covid-19, should use function auth
  public showPosting: boolean = false;
  public marginTopMenu: number = 182;

  public subscribption: any = [];
  public taskList: any = [];
  public taskLimit: number = 3;
  public taskPage: number = 1;
  public taskForPeople: any = [];

  public limitTeammates: number = 5;
  public teammatesList: Array<any>;
  public currentSPV: any;
  public favouriteMenu: any = [];
  public selectedTabTask: any;
  public Supervisor: any = []
  public teammates: any = []
  public feed: string = 'All';
  public isMoore: boolean = true;
  public swipe: any;
  public dataAnnouncement: any = [];
  public formDataAnnouncement = {
    page: 1,
    limit: 3,
    totalPage: 1,
  }
  public showTeammates: Boolean = false;
  public showMyonboarding: Boolean = false;
  public showCompanyOnboarding: Boolean = false;

  public iscompany: boolean[];
  public urlLogo: any;
  public myScore: any;

  // Dropdown header
  public isDropmenu: boolean = false;
  public isOutside: boolean = true;
  public listDropmenu: any[] = [];
  public multicompany: { status: boolean, company: string }[] = [];
  public languageSelected2: any;
  public languageList: any[];

  public isBannerDanafix: Boolean = false;
  public spvDetail: any;
  public allowAttendance: boolean = true;
  public isIphone5: boolean = false;
  public isIos: boolean = false;
  public lastMenu: any = [];
  public totalMenu: any;
  public language: string;
  public skeletonMenu: boolean = true;
  public totalSkeletonMenu: any;
  public skeletonTask: boolean = true;
  public skeletonTeam: boolean = true;
  public skeletonCompany: boolean = false;
  public companyList: any = [];
  public companySelected: any;
  public dataEmployee: any;
  public dummyLocked: boolean = false;
  public toggleLocked: boolean = false;
  public skeletonFeed: boolean = true;
  public myCompany: any;
  public isSendPost: boolean = false;
  public uploadPostDone: boolean = false;
  public SFGoStorage: GDStorageInterface;
  public storedPrelogin: StoredPrelogin;
  public selectedLink: string;
  public youtubeLink = {
    id: 'https://www.youtube.com/watch?v=SP3PiQFW1Qg',
    en: 'https://www.youtube.com/watch?v=Ca6om8AWMjc'
  }
  public surveyLink = 'https://t.maze.design/26981513';
  // public showSurvey = true;

  public attOfflineList: Array<any> = [];
  public toggleSnackbar: boolean = false;
  public paramsFeed: RequestGetFeedDto = { limit: 10, skip: 0, flag: null };
  public unreadChat: number = 0;
  public gamification: boolean = false;
  public isSyncAttendance: boolean = false;

  public emergencyAnnoucement: any;

  public showAnnoucement: boolean = false;

  public partnerCovid: any;

  sosPosition: any = {
    top: '275px',
    right: ''
  }

  public showPanicButton: boolean = false;
  public toggleResourceBook: boolean = false;
  public dataResourceBook: any = {};
  public onBoardProgress: number = 0;
  public achievementList: any[] = [];
  public myBadge: any;

  public multiAccountActive: boolean;
  readonly progress: Observable<number>;
  public firstname: any;
  public nickname: any;
  public tempCompanySelected = null;
  public intercomIsLaunched = false;

  constructor(
    public app: App,
    public popoverCtrl: PopoverController,
    public menuCtrl: MenuController,
    public platform: Platform,
    public navCtrl: NavController,
    public events: Events,
    public toastCtrl: ToastController,
    public viewCtrl: ViewController,
    public storage: Storage,
    public tsfeedserviceApi: TsfeedserviceApi,
    public tspostserviceApi: TspostserviceApi,
    public rt: RealTime,
    public actionSheetCtrl: ActionSheetController,
    public auth: LoopBackAuth,
    public SunfishApi: SunfishApi,
    public register: RegistrationNewApi,
    public introProvider: IntroProvider,
    public translate: TranslateService,
    public feedServiceApi: FeedServiceApi,
    public accessmanagementApi: AccessmanagementApi,
    public permissionCheckProvider: PermissionCheckProvider,
    public alertCtrl: AlertController,
    public diagnostic: Diagnostic,
    public customPlugin: CustomPluginProvider,
    public camera: Camera,
    public sfattendanceApi: SFAttendanceApi,
    public toastService: ToastServiceProvider,
    public alertService: AlertServiceProvider,
    public settingServiceApi: SettingServiceApi,
    public modalCtrl: ModalController,
    public attendanceBloc: AttendanceBloc,
    public personalNestApi: PersonalNestApi,
    public SfRequestApi: SfRequestApi,
    public iab: InAppBrowser,
    public analyticsProvider: AnalyticsProvider,
    public chatServiceProvider: ChatServiceProvider,
    public sockeIoClientProvider: SocketIoClientProvider,
    public SFPolicyApi: SFPolicyApi,
    public ngZone: NgZone,
    public element: ElementRef,
    public renderer: Renderer,
    public inAppBrowser: InAppBrowser,
    public globalService: GlobalServiceProvider,
    public menuService: MenuProvider,
    public sunfishApi: SunfishApi,
    public homeFeedProvider: HomeFeedProvider,
    public announcementProvider: AnnouncementProvider,
    public leaderBoardApi: LeaderBoardApi,
    public navParams: NavParams,
    public nestApiProvider: NestApiProvider,
    public appGuideProviders: AppGuideProviders,
    public payDayLoanServiceApi: PaydayLoanServiceApi,
    private socketIoClientProvider: SocketIoClientProvider,
    public loadingService: LoadingServiceProvider,
    public nestResponses: NestResponsesProvider,
    public personalApi: PersonalApi,
    private menuRepository: PageBuilderMenuProvider,
    public homeFeedStateProvider: HomeFeedStateProvider,
    public sfgoAuthService: SFGOAuthService,
    public storagePathProvider: StoragePathProvider,
    public postServiceApi: PostServiceApi,
    public requestInboxApi: RequestInboxApi,
    public authNestApi: AuthApi,
    public nestAuth: NestAuthProvider,
    public loadingCtrl: LoadingController,
    public saasProvider: SaasProvider,
    public featurePageProvider: PageBuilderFeaturePageProvider,
    public feedServiceNestApi: FeedServiceNestApi,
    public homeBloc: HomeBloc,
    public builderServiceApi: BuilderServiceApi,
    public pageBuilderGlobal: PageBuilderGlobal,
    public appVersion: AppVersion,
    public appPreferences: AppPreferences,
    public subscriptionService: SubscriptionServiceApi,
    public gamificationProvider: GamificationProvider,
    public policyApi: SF6SPolicyApi,
    public initializeBloc: InitializeBloc,
    public backgroundGeolocationBloc: BackgroundGeolocationBloc,
    public yesDokServiceApi: YesdokserviceApi,
    public pollingBloc: PollingBloc,
    public companyBloc: CompanyBloc,
    public authenticationBloc: AuthenticationBloc,
    private versionServiceProvider: PageBuilderVersionProvider,
    public yesdokService: YesdokService,
    private onBoardingBloc: OnBoardingBloc,
    private companyMoodBloc: CompanyMoodBloc,
    private multipleAccountBloc: MultipleAccountBloc,
    public companySetupBloc: CompanySetUpBloc,
    public chatSupportService: ChatSupportService,
    public navigationService: NavigationService,
    private worklocationServiceProvider: WorklocationServiceProvider,
  ) {
    this.progress = this.emulateProgress();
  }

  async ngOnInit() {
    this.menuService.newHome = true;
    this.nestApiProvider.setHost();
    this.chatServiceProvider.getGoPath();
    this.sockeIoClientProvider.getGoPath();

    this.platform.resume.subscribe(() => { this.isDisabled = false });
    this.languageList = this.globalService.languageList
    this.languageSelected2 = this.navParams.get('language');
    this.menuService.newHome = true;
    this.isIos = this.platform.is('ios') ? true : false;
    this.selectedLink = this.language == 'id' ? this.youtubeLink[this.language] : this.youtubeLink['en'];

    /** No-auth UI Initialization **/
    await this.openGuide();
    this.setSkeletonMenu();
    this.checkPollingAfterLogin();
    this.initView();
    this.initDropDownMenu();
    this.definePostEmpty();
    this.getMore();
    this.announcementEmergency();
    this.getYesdokNotification();
    this.showAttendanceAfterSurvey();
    this.attendanceBloc.setBasePhoto();
    this.worklocationServiceProvider.todayForm();
    // this.checkSurvey();
  }

  async ionViewDidLoad() {
    try {
      /** Always on top function */
      this.SFGoAuth = await this.appPreferences.getAuth();

      this.initProfilePicture();
      await this.appPreferences.setAuth(this.SFGoAuth);
      this.gamification = this.SFGoAuth.menu["gamification"];
      this.SFGoStorage = await this.sfgoAuthService.getGDStorage();
      this.storedPrelogin = this.SFGoStorage.storedPrelogin;

      try {
        this.nickname = (this.SFGoAuth.nickname && this.SFGoAuth.nickname != "") ? this.SFGoAuth.nickname : this.SFGoAuth.fullName.split("")[0];
        this.firstname = this.SFGoAuth.fullName.split("")[0];
      } catch (error) { }

      await this.initMenuTop();
      await this.hideOverlay();

      /** Get Data Temporary From Storage */
      await this.getTempCompany();
      await this.getTempSettingPost();
      await this.getTempTeamMates();
      await this.getTempTodayTask();
      await this.getTempAnnouncement();
      await this.initEvents();

      if (this.socialMedia) {
        await this.initFormPosting()
      } else {
        this.showPosting = false;
      }

      await this.loadMultiCompany();
      await this.getMyCompany(this.SFGoAuth.accId || this.SFGoAuth.companyId);
      await this.initDynamicData();
      await this.initialize();
      // await this.getTrackPolicy();
      await this.iniDataOnboarding();
      this.getUnreadChat();

      /** Update credit subscription */
      await this.updateSubscriptionCredit();

      if (this.SFGoAuth.menu.tracking) {
        await this.backgroundGeolocationBloc.initBackGroundLocation().catch();
      }

      if (this.SFGoAuth.menu['company-onboarding']) {
        this.initOnboarding();
      }

      this.getBadgeOnAvatar();
    } catch (error) {
      console.log('TCL: error', error);
    }
  }

  async ngAfterViewInit() {    /** update func auth fav menu in storage */
    this.analyticsProvider.setUserPropertyAnalytics();
    await this.menuRepository.updateAuthFavoriteMenu();
  }

  async ionViewWillEnter() {
    this.start2show = false;
    const istotalCommand = this.navParams.get('totalCommand') || 0;
    const isIndexCommand = this.navParams.get('index') || 0;

    if (istotalCommand !== 0 || isIndexCommand !== 0) {
      this.setCommandCount(istotalCommand, isIndexCommand);
    }

    this.initLanguage();
  }

  async ionViewDidEnter() {
    this.SFGoAuth = await this.appPreferences.getAuth();
    this.checkAttOfflineData();

    if (!this.SFGoAuth) {
      this.navCtrl.setRoot('PageInitPage');
    }

    await this.initUserInfo();
    await this.initLocaleMomentJS();

    this.events.unsubscribe("chat:unreadrefresh");
    this.events.subscribe("chat:unreadrefresh", () => {
      this.getUnreadChat();
    });

    this.events.unsubscribe("taskFeedback:refreshTask");
    this.events.subscribe("taskFeedback:refreshTask", async () => {
      await this.getTodayOwnTask();
      await this.getTodayTask();
    });

    this.initializeBloc.initStatusBar();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.homeBloc.dispose();
    this.events.unsubscribe('attendance:success-record-attendance');
    this.events.unsubscribe('language:change');
    this.events.unsubscribe('favorite:refresh');
  }

  async initialize(): Promise<any> {
    return new Promise(async (resolve) => {
      /** Set Host Nest Api */
      await this.nestApiProvider.initializeAuth();
      this.sendRecordsOfflineAtt();
      await this.flagCard();
      await this.getFeed();
      // await this.getMyScore();
      await this.loadRequestBadge()
      await this.loadOnBoarding()

      resolve(true);
    })
  }

  initView(): Promise<any> {
    return new Promise(async (resolve) => {
      this.holder = this.holderArea.nativeElement;
      this.modalWrapper = this.modalArea.nativeElement;
      this.menuCtrl.swipeEnable(false);

      // SWIPE Gesture end
      if (!this.platform.is('ios')) {
        this.isIos = false;
        // PAN Gesture start
        this.panicPanGesture();
        this.panDown = new window['Hammer'](this.holder);
        this.panDown.add(new window['Hammer'].Pan({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 }));
        this.panDown.on('pan', (ev) => {

          if (!this.isDragging) {
            this.isDragging = true;
            if (this.isOpen) {
              this.lastPosY = this.showMenuMobile;
            } else {
              this.lastPosY = this.hideMenuMobile;
            }
          }

          this.posYExp = ev.deltaY + this.lastPosY;

          if (this.posYExp >= this.hideMenuMobile && this.posYExp <= this.showMenuMobile) {
            this.modalWrapper.style.transform = 'translateY(' + this.posYExp + 'px)';
            this.modalWrapper.style.transition = 'all 0ms';
          }

          if (ev.isFinal) {
            this.isDragging = false;
            if (this.posYExp > 170) {
              this.isOpen = true;
              this.modalWrapper.style.transform = 'translateY(' + this.showMenuMobile + 'px)';
              this.modalWrapper.style.transition = 'all 200ms';
              // this.lastDeltaY = ev.deltaY;
              ev.deltaY = this.hideMenuMobile + 5;
            } else if (this.posYExp <= 170) {
              this.isOpen = false;
              this.modalWrapper.style.transform = 'translateY(' + this.hideMenuMobile + 'px)';
              this.modalWrapper.style.transition = 'all 200ms';
            }
          }
        });
      }
      // PAN Gesture end

      this.windowXsize = window.innerWidth;
      this.windowYsize = window.innerHeight;
      if (this.windowXsize < this.tabletSize) {
        this.isMobile = true;
        this.isTablet = false;
        this.isWrapping = true;
      } else if (this.windowXsize >= this.tabletSize && this.windowXsize <= this.tabletProSize) {
        this.isTablet = true;
        this.isMobile = false;
        this.isWrapping = true;
      } else {
        if (!this.isWrapping) {
          await this.unwrap();
          this.isUnwrap = true;
        }
        this.isMobile = false;
        this.isTablet = false;
      }

      if (this.menuService.newHome) {
        if (window.innerWidth < this.tabletSize) {
          this.isMobile = true;
          this.isTablet = false;
          // JUMLAH ICON MENU on LOAD
          let widthIcon = 70 * 5;
          if (window.innerWidth < widthIcon) {
            this.decrease = 1;
          } else {
            this.decrease = 0;
          }

          // POST WIDTH on LOAD
          let innerWidth = window.innerWidth;
          this.aPwidth = innerWidth - 36;
          this.aPmaXwidth = innerWidth - 36;
          this.postFxWidth = innerWidth - 103.8;

          if (!this.isUnwrap) {
            // this.wrapping();
          }
          this.isWrapping = true;
        } else if (window.innerWidth >= this.tabletSize && window.innerWidth <= this.tabletProSize) {
          this.isTablet = true;
          this.isMobile = false;

          let innerWidth = window.innerWidth;
          this.aPwidth = innerWidth - 36;
          this.aPmaXwidth = innerWidth - 36;
          this.postFxWidth = innerWidth - 103.8;

          this.isWrapping = true;
        } else {
          if (!this.isWrapping) {
            await this.unwrap();
            this.isUnwrap = true;
          }

          this.isMobile = false;
          this.isTablet = false;
          this.aPwidth = '100%';
        }

        let offTopEl = this.addpost.nativeElement.offsetTop;
        let offTopParEl = this.addpost.nativeElement.offsetParent ? this.addpost.nativeElement.offsetParent.offsetTop : 0;

        this.topPost = offTopEl + offTopParEl;
        let offLeftEl = this.addpost.nativeElement.offsetLeft;
        let offLeftParEl = this.addpost.nativeElement.offsetParent ? this.addpost.nativeElement.offsetParent.offsetLeft : 0;
        let offLeftPar2El = this.addpost.nativeElement.offsetParent ? this.addpost.nativeElement.offsetParent.offsetParent.offsetParent.offsetParent.offsetParent.offsetLeft : 0;
        this.leftPost = offLeftEl + offLeftParEl + offLeftPar2El;

        this.widthPost = this.addpost.nativeElement.offsetWidth;
        this.menuCtrl.swipeEnable(false);
      }
      else {
        this.menuCtrl.swipeEnable(true);
      }
      if (this.platform.width() > 1280) {
        this.slideView = 3
      } else if (window.innerWidth > 767) {
        this.slideView = 2
      } else {
        this.slideView = 1.5
      }

      // LOGIC ICON MENU HOME MOBILE PHONE SE
      if (window.innerWidth < 359) {
        this.isIphone5 = true;
        this.menuCount = 1;
      } else {
        this.isIphone5 = false;
        this.menuCount = 2;
      }

      resolve(true);
    })
  }

  initMenuTop(): Promise<any> {
    return new Promise(async (resolve) => {
      this.menuCtrl.swipeEnable(false);

      // Untuk ISS (Sementara)
      if (this.SFGoAuth.companyCode == 'issid') {
        this.isISS = true;
      } else {
        this.isISS = false;
      }

      this.skeletonMenu = true;
      await this.checkFavMenu();

      this.pages = [
        { title: 'Attendance', component: 'TimeAttendance', icon: 'assets/images/icon/clock-head-icon.svg', show: false },
        { title: 'Leave', component: 'leave2Page', icon: 'assets/images/icon/leave-icon.svg', show: true },
        { title: 'Request', component: 'RequestPage', icon: 'assets/images/icon/request-icon.svg', show: true },
        { title: 'Great Day', component: 'LeaderboardPage', icon: 'assets/images/icon/greaday-icon.svg', show: false },
        { title: 'Payroll', component: 'Payroll2Page', icon: 'assets/images/icon/payroll.svg', show: false }
      ];

      this.menuCtrl.enable(true);

      if (this.isSF6) {
        this.pages.find(function (fi) {
          return fi.title == 'Great Day'
        }).show = false;
      } else {
        this.pages.find(function (fi) {
          return fi.title == 'Attendance'
        }).component = 'TimeAttendanceSfgoPage';
        this.pages.find(function (fi) {
          return fi.title == 'Great Day'
        }).show = true;
      }
      //end

      let listMenu = this.SFGoAuth.menu;
      let tempMenuName; //temp

      if (listMenu == undefined) {
        // this.events.publish('user:logout', '')
      } else {
        if (listMenu["social-media"] != undefined) {
          this.socialMedia = listMenu["social-media"];
        }

        if (listMenu["post"] != undefined) {
          if (!this.socialMedia) {
            this.socialMedia = listMenu["post"];
          }
        }

        if (listMenu["banner-survey"] != undefined) {
          this.bannerSurvey = listMenu["banner-survey"];
        }

        if (listMenu["task"] != undefined) {
          this.tasknFeedBack = listMenu["task"];
          this.tasknFeedBackButtonAdd = this.SFGoAuth.menu['task-button-add'];
        }

        if (listMenu["team-mates"] != undefined) {
          this.showTeammates = listMenu["team-mates"];
        }

        if (listMenu["my-onboarding"] != undefined) {
          this.showMyonboarding = listMenu["my-onboarding"];
        }

        if (listMenu["com-announcement"] != undefined) {
          this.showAnnoucement = listMenu["com-announcement"];
        }

        if (listMenu["company-onboarding"] != undefined) {
          this.showCompanyOnboarding = listMenu["company-onboarding"];
        }

        tempMenuName = "att-entry";
        this.pages.find(function (fi) {
          return fi.title == 'Attendance'
        }).show = listMenu[tempMenuName];
        this.allowAttendance = listMenu[tempMenuName];

        tempMenuName = "att-leave";
        this.pages.find(function (fi) {
          return fi.title == 'Leave'
        }).show = listMenu[tempMenuName];

        if (this.isSF6) {
          tempMenuName = "payroll";
          this.pages.find(function (fi) {
            return fi.title == 'Payroll'
          }).show = listMenu[tempMenuName];

          tempMenuName = "request-notification";
          this.pages.find(function (fi) {
            return fi.title == 'Request'
          }).show = (listMenu[tempMenuName]) ? true : (listMenu[tempMenuName] == null || listMenu[tempMenuName] == undefined) ? true : false;
        } else {
          tempMenuName = "payroll";
          this.pages.find(function (fi) {
            return fi.title == 'Payroll'
          }).show = false;
        }

        tempMenuName = "panicbutton";
        if (listMenu[tempMenuName]) {
          if (this.platform.is('cordova')) {
            this.showPanicButton = listMenu[tempMenuName];
          } else {
            tempMenuName = "panicbutton-web";
            this.showPanicButton = listMenu[tempMenuName];
          }
        }

        this.multiAccountActive = this.SFGoAuth.menu["multi-account"];
      }

      this.recalcMarginTopMenu();
      this.skeletonMenu = false;

      await this.setBannerShow(listMenu);

      let isFlagStartedthis = await this.storage.get('FlagStarted');
      if (isFlagStartedthis != null) {
        if (isFlagStartedthis.flag == false) {
          this.overlayStarted = false;
        } else {
          this.overlayStarted = true;
        }
      } else {
        this.overlayStarted = true;
      }

      resolve(true);
    });
  }

  recalcMarginTopMenu() {
    let notificationHeight: number;
    if (this.notificationBox != null) {
      notificationHeight = this.notificationBox.nativeElement.offsetHeight - 6;
    } else {
      notificationHeight = 94 + 8 + 8;
    }
    this.marginTopMenu = 182 + (this.showNotif && !this.closeNotif ? notificationHeight : 0);
  }

  async initFormPosting(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let GDSetting = await this.attendanceBloc.getAttendanceSetting();
        this.showPosting = GDSetting.hasOwnProperty('showPosting') ? GDSetting.showPosting : true;
        this.recalcMarginTopMenu();
        resolve(true);
      } catch (error) {
        this.showPosting = true;
        this.recalcMarginTopMenu();
        resolve(true);
      }
    })
  }

  initDynamicData(): Promise<any> {
    return new Promise(async (resolve) => {
      /** SET HOST NEST API */
      await this.nestApiProvider.initializeAuth();
      await this.checkAttendance();

      if (this.menuService.newHome) {
        if (this.showTeammates) {
          await this.getTeammates();
        }
        if (this.tasknFeedBack) {
          await this.getTodayOwnTask();
          await this.getTodayTask();
        }
        if (this.showAnnoucement) {
          await this.getAnnouncement();
        }
      }

      if (!this.platform.is('cordova') && this.teammatesComponent && this.menuService.newHome) {
        await this.teammatesComponent.getSupervisor();
        await this.teammatesComponent.getCoWorker();
        await this.teammatesComponent.getSubordinate();
        await this.teammatesComponent.getFavourite();
      }

      resolve(true);
    })
  }

  initLanguage(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        await this.storage.ready();
        this.language = await this.storage.get("language");

        if (this.language != null && this.language !== undefined) {
          this.languageSelected = this.language;
          if (this.languageSelected == 'en') {
            this.languageSelected2 = 'English'
          } else if (this.languageSelected == 'id') {
            this.languageSelected2 = 'Indonesia'
          } else if (this.languageSelected == 'th') {
            this.languageSelected2 = 'Thailand'
          } else if (this.languageSelected == 'cn') {
            this.languageSelected2 = 'Chinese'
          } else if (this.languageSelected == 'kr') {
            this.languageSelected2 = 'Korean'
          } else if (this.languageSelected == 'jp') {
            this.languageSelected2 = 'Japanese'
          } else if (this.languageSelected == 'my') {
            this.languageSelected2 = 'Malaysia'
          }
        }

        resolve(true);
      }
      catch (error) {
        resolve(true);
      }
    })
  }

  initEvents(): Promise<any> {
    return new Promise((resolve) => {
      try {
        if (this.menuService.newHome) this.events.publish('company:loadmultiplecompany', true);

        if (!this.globalService.checkRouteFromLogin()) {
          this.events.publish('user:created', 'fromhome');
        }

        this.events.subscribe('attendance:checkofflinedata', (data) => {
          this.isSyncAttendance = false;
          this.checkAttOfflineData();
        });

        this.events.subscribe('OFFLINEMODE:RUNSYNCATTENDANCEOFFLINERECORD', (userEventData) => {
          this.toggleSnackbar = false
        });

        this.events.subscribe('ATTENDANCE:RECORDATTENDANCEONLINE', (recordAttendance) => {
          this.isSyncAttendance = true;
          this.toggleSnackbar = false;
        });

        /**
        * LISTENER AFTER SUCCESS RECORD ATTENDANCE
        */
        this.events.unsubscribe('attendance:success-record-attendance');
        this.events.subscribe('attendance:success-record-attendance', async (val) => {
          if (val) {
            // check uptodate data attendance
            await this.checkAttendance();

            const authCompanyMode = this.SFGoAuth.menu["company-mood"];
            if (authCompanyMode) {
              // Check survey employee company mood
              await this.companyMoodBloc.checkEmployeeSurvey();
            }

            // check gamification
            if (!this.clockOut && this.gamification) {
              await this.gamificationProvider.checkAchievement(badgeModule.attendanceIn);
            }
            // check survey polling after attendance
            await this.checkPollingAfterAttendance();
          }
        });

        this.events.subscribe('company:loadmultiplecompany', (val) => {
          if (this.menuService.newHome) {
            this.loadMultiCompany();
          }
        });

        this.events.subscribe('home2:hiddenFab', (data) => {
          this.showIntro = data;
          this.storage.set('intro', JSON.stringify({ status: data }));
        });

        this.events.subscribe('language:change', async () => {
          this.ngZone.run(async () => {
            this.language = await this.storage.get("language");
            this.selectedLink = this.language == 'id' ? this.youtubeLink[this.language] : this.youtubeLink['en'];
            this.getTodayOwnTask();
            this.getTodayTask();
            this.getAnnouncement();
            this.getFeed();
            this.switchLang();
          })
        });

        this.events.subscribe('home2:reloadreq', async (data) => {
          this.loadRequestBadge();
          this.getFeed();
        });

        this.events.subscribe('post:liked2', (data) => {
          let index = this.findIndexByKeyValue(this.dataFeed, 'postingidunix', data.postingidunix);
          if (data.total != null && data.total != undefined && index != null && index != undefined) {
            this.dataFeed[index].likesCount = data.total;
            this.dataFeed[index].isLike = data.status;
          } else {
            this.dataFeed[index].likesCount = 0;
            this.dataFeed[index].isLike = false;
          }
        });

        this.events.subscribe('profile:change-profile-picture', async (photoName) => {
          this.initProfilePicture(photoName);
        });

        this.events.subscribe('post:loadhome', () => {
          this.getFeed();
        });

        this.events.subscribe('favorite:refresh', () => {
          this.teammatesComponent.getFavourite();
        });

        this.events.unsubscribe('attendance:sendtoaws');
        this.events.subscribe('attendance:sendtoaws', async (data) => {
          await this.attendanceBloc.sendRecordToAWS(data);
        });

        this.events.subscribe('home:resourcebooking', async (data) => {
          const arrData = [data];
          await this.initResouceBooking(arrData, false);
        });

        this.events.unsubscribe(EventLabel.SWITCH_ACCOUNT_RELOAD);
        this.events.subscribe(EventLabel.SWITCH_ACCOUNT_RELOAD, (data: SwitchAccountResponse) => {
          this.switchAccountReload(data);
        });

        /** LISTEN PERUBAHAN BADGE AVATAR */
        this.homeBloc.subscriptions.push(
          this.gamificationProvider.badgeChanged.subscribe(() => {
            this.getBadgeOnAvatar()
          })
        )

        // Favorite Update After getMenuV2
        this.events.subscribe('favorite:update', () => {
          this.checkFavMenu();
        });

        // Switch account
        this.events.unsubscribe(EventLabel.SWITCH_ACCOUNT_RELOAD_HOME);
        this.events.subscribe(EventLabel.SWITCH_ACCOUNT_RELOAD_HOME, () => {
          this.events.publish(EventLabel.USER_CREATED);
          this.navCtrl.setRoot(RootPage.page);
        });
      } catch (error) { }
      resolve(true);
    })
  }

  async initLocaleMomentJS(): Promise<any> {
    return new Promise(async (resolve) => {
      let language = await this.storage.get("language");

      if (language == 'id') {
        moment.locale('id')
      }
      else {
        moment.locale('en')
      }
      resolve(true);
    })
  }

  initUserInfo(): Promise<any> {
    return new Promise((resolve) => {
      try {
        this.empphotopath = this.SFGoAuth.empphotopath || null;
        this.companyCode = this.SFGoAuth.companyCode;
        this.name = this.SFGoAuth.fullName;
        this.position = this.SFGoAuth.position;
        this.userId = this.SFGoAuth.userId;
        this.empId = this.SFGoAuth.empId;
        if (this.SFGoAuth.isSF6 == 1) {
          this.isSF6 = true;
        } else {
          this.isSF6 = false;
        }
      } catch (error) { }
      resolve(true);
    });
  }

  initProfilePicture(photoName?: string) {
    const time = new Date().getTime().toString();
    this.photoProfile = photoName ? photoName : this.SFGoAuth.photo;
    if (this.SFGoAuth.isSF6) {
      try {
        const paramsArray = this.SFGoAuth.empphotopath.split('?');
        if (paramsArray.length <= 1) {
          this.photoProfile = `${this.photoProfile}?${time}`;
        } else {
          this.photoProfile = `${this.photoProfile}&${time}`;
        }
      } catch (error) {
        console.log(error);
        this.photoProfile = `${this.photoProfile}&${time}`;
      }
    } else {
      this.photoProfile = `${this.photoProfile}&${time}`;
    }
  }

  iniDataOnboarding(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        if (this.SFGoAuth.isSF6 == 1) {
          this.isSF6 = true;
        } else {
          this.isSF6 = false;
          let isHrAdmin = this.SFGoAuth.isHRAdmin;
          if (isHrAdmin == false) {
            this.isHR = false;
            let isSpv = await this.SpvCheck();
            if (isSpv == false) {
              this.isSpv = false;
              let params = {
                "type": "user"
              }
              this.statusUser = "user";
              await this.checkDataOnboarding(params);
            } else {
              this.isSpv = true;
              let params = {
                "type": "superior"
              }
              this.statusUser = "superior";
              await this.checkDataOnboarding(params);
            }
          } else {
            this.isHR = true;
            let params = {
              "type": "hrAdmin"
            }
            this.statusUser = "admin";
            await this.checkDataOnboarding(params);
          }
        }
      } catch (error) { }
      resolve(true);
    });
  }

  showLocked() {
    if (this.dummyLocked) {
      this.toggleLocked = true;
      setTimeout(() => {
        this.toggleLocked = false;
      }, 15000);
    }
  }

  /** GET DATA TEMPORARY FROM STORAGE */
  getTempTeamMates(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const date = new Date().toISOString().substr(0, 10).replace(/-/g, '');
        let teamMates = await this.storage.get('teammate' + date);
        if (teamMates) {
          teamMates = JSON.parse(teamMates);
          this.skeletonTeam = false;
          this.teammatesList = teamMates;
        }
        resolve(true);
      }
      catch (error) {
        console.log(error);
        resolve(true);
      }
    })
  }

  getTempCompany(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let company = await this.storage.get('company');
        if (company) {
          company = JSON.parse(company);
          this.myCompany = company;
          this.companyName = this.myCompany.companyName;
          this.taxCountry = this.myCompany.taxcountry;
          this.urlLogo = this.myCompany.companyLogo;
        }
        resolve(true);
      }
      catch (error) {
        resolve(true);
      }
    })
  }

  getTempTodayTask(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let todayTask = await this.storage.get('todayTask');
        if (todayTask) {
          todayTask = JSON.parse(todayTask);
          this.taskList = todayTask;
          this.isFix = false;
          this.skeletonTask = false;
          this.selectedTabTask = this.taskList;
        }
        resolve(true);
      }
      catch (error) {
        console.log(error)
        resolve(true);
      }
    })
  }

  getTempAnnouncement(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let announcement = await this.storage.get('announcement');
        if (announcement) {
          announcement = JSON.parse(announcement);
          this.dataAnnouncement = announcement;
          this.skeletonCompany = false;
        }
        resolve(true);
      }
      catch (error) {
        console.log(error);
        resolve(true);
      }
    })
  }

  getTempSettingPost(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let GDSetting = await this.attendanceBloc.getAttendanceSetting();
        GDSetting = GDSetting ? GDSetting : null;
        if (GDSetting) {
          let isShow = GDSetting.hasOwnProperty('showPosting') ? GDSetting.showPosting : true;
          this.showPosting = isShow;
        }

        resolve(true);
      } catch (error) {
        this.showPosting = true;
        resolve(true);
      }
    })
  }
  /** END */

  loadMultiCompany(): Promise<any> {
    return new Promise((resolve) => {
      this.companyList = this.SFGoAuth.multiCompany && this.SFGoAuth.multiCompany.company_list ? this.SFGoAuth.multiCompany.company_list : [];
      this.companySelected = this.SFGoAuth.accId || this.SFGoAuth.companyId;

      if (this.companyList[0].company_code == 'fabgroup') {
        this.getMyCompany(this.companyList[0].company_id);
      }
      resolve(true)
    })
  }

  /** add by AR */
  async changeCompany(value) {
    try {
      this.isSwitchComp = true;
      this.tempCompanySelected = value;

      if (this.platform.is('cordova') || this.platform.is('android') || this.platform.is('ios')) {
        await this.navCtrl.push("ProgressbarPage", { isSwitchCompany: true });
      }

      await this.initializeBloc.switchCompany(value);
      this.companySelected = value;
      this.SFGoAuth = await this.appPreferences.getAuth();
      await this.getMyCompany(value);
      await this.menuRepository.updateAuthFavoriteMenu();
      await this.initMenuTop();
      await this.doRefreshNew();
    } catch (error) {
      this.nestResponses.error(error);
    } finally {
      this.isSwitchComp = false;
      this.tempCompanySelected = null;
      this.events.publish(EventLabel.COMPANY_SWITCH_DONE);
    }
  }

  initDropDownMenu(): Promise<boolean> {
    try {
      this.listDropmenu = [
        {
          icon: 'assets/icon_new/paper-grey.svg',
          name: 'Profile',
          show: true
        },
        {
          icon: 'assets/icon_new/language-icon.svg',
          name: 'Language',
          show: true
        },
        {
          icon: 'assets/icon_new/headphones-grey.svg',
          name: 'Support',
          show: this.appPreferences.dataAuth.menu['intercom'] ? true : false
        },
        {
          icon: 'assets/icon_new/setting-grey.svg',
          name: 'Setting',
          show: true
        },
        {
          icon: 'assets/icon_new/logout-grey.svg',
          name: 'Logout',
          show: true
        },
      ]
    } catch (error) { }
    return Promise.resolve(true);
  }

  multic(company) {
    this.multicompany.forEach(element => {
      if (element.company == company) {
        element.status = true;
      }
      else { element.status = false; }
    });
  }

  definePostEmpty(): Promise<any> {
    return new Promise((resolve) => {
      this.postEmpty = [{
        type: 'EMPTY',
        createddate: new Date(),
        header: 'Welcome to SunFishGo',
        content: 'There are no record yet'
      }];
      resolve(true);
    })
  }

  async doRefreshNew(refresher?: any) {
    await this.backgroundGeolocationBloc.checkIsRunning();

    this.checkAttendance();
    this.getTodayOwnTask('refresh');
    this.getTodayTask();
    this.getAnnouncement();
    this.getUnreadChat();
    if (!this.platform.is('cordova') && this.teammatesComponent && this.menuService.newHome) {
      this.teammatesComponent.getCoWorker();
      this.teammatesComponent.getSubordinate();
      this.teammatesComponent.getSupervisor();
      this.teammatesComponent.getFavourite();
    }

    this.getTeammates();
    this.loadRequestBadge();
    this.getFeed();
    this.socialMedia ? await this.initFormPosting() : this.showPosting = false;
    this.events.publish('attendance:checkofflinedata', true);
    await this.initUserInfo();
    this.initProfilePicture();
    this.isRecordTime = false;

    try {
      this.versionServiceProvider.getVersion();
    } catch (error) { }

    if (this.showNotif) {
      this.closeNotif = false;
      setTimeout(() => {
        // timeout wait #notificationBox to appear
        this.recalcMarginTopMenu();
      }, 100);
    }

    this.attendanceBloc.setBasePhoto();
    setTimeout(() => {
      if (refresher) refresher.complete();
    }, 2000);

    return true;
  }

  startPulling(e) {
    if (this.isDragging) {
      e.cancel();
    }
  }

  closeNotifhome() {
    this.closeNotif = true;
    this.recalcMarginTopMenu();
    this.initializeBloc.closeEmergencyAnnouncement();
  }

  gotoWeb(link: string) {
    const opt: InAppBrowserOptions = {
      "location": "no",
      "clearcache": "yes",
    }
    const browser = this.inAppBrowser.create(link, '_blank', opt);
    browser.show();
  }

  async openMenuModal() {
    this.SFGoAuth = await this.appPreferences.getAuth();
    if (this.SFGoAuth.isSF6 && this.SFGoAuth.resetPassword == true) {
      this.navCtrl.setRoot('ChangePassPage', { fromLogin: true });
      return;
    }
    this.isMoore = false;
    await this.setMore();
    let modal = this.modalCtrl.create('GdMenuPage', { unreadChat: this.unreadChat }, { cssClass: "gd-modal-controller" });

    modal.onDidDismiss(data => {
      try {
        if (data == 'home2page') {
          // this.transitionLayout();
          return;
        }

        if (data && data.action === 'switchAccount') {
          return;
        }

        if (data.title == 'Logout') {
          this.events.publish('user:logout');
        } else if (data == 'Setting') {
          this.events.publish('user:setting');
        } else if (data == 'appversion') {
          this.events.publish('user:appversion');
        } else if (data == 'close') { }
        else if (data == 'profil') {
          this.navCtrl.push('ProfileHomePage');
        } else if (data.type == 'builder') {
          this.events.publish('user:getpagebuilder', data.content);
        } else if (data.type == 'static') {
          this.events.publish('user:getstaticbuilder', data.content);
        } else if (data.type == 'custom') {
          this.events.publish('user:getcustom', data.content);
        } else if (data === 'logout multi') {
          this.navCtrl.setRoot('SwitchAccountPage');
        } else {
          data.typeMenu = 'push';
          this.events.publish('user:openPage', data);
        }
      } catch (error) {
        console.log(error);
      }
    })
    modal.present();
  }

  toCompany() {
    this.featurePageProvider.getPageFeatureByCode('HOME.COMPANY.PROFILE').then(page => {
      let pageId = page.pageId;
      if (pageId) {
        this.openPageBuilder(pageId);
      } else {
        this.navCtrl.push("CompanyProfile");
      }
    });
  }

  openPageBuilder(pageId, pageParamAsBody?) {
    let navParam = {
      pageId: pageId,
      pageTitle: 'Loading...',
      pageType: null,
      pageSchema: null,
      pageFile: null,
      pageParam: [],
      pageIsSub: false,
      userId: null,
      static: null,
      cacheDuration: null,
      cacheStart: null,
      version: null,
      typeMenu: 'push',
      pageParamAsBody: pageParamAsBody
    }

    this.storage.remove('pageBuilderActive');
    this.navCtrl.push('InitPageBuilder', navParam);
  }

  ModalTeammates() {
    if (!this.dummyLocked) {
      this.navCtrl.push("GdTeammatesPage", { tasknFeedBack: this.tasknFeedBack });
    }
  }

  openQuickTask(data) {
    if (this.tasknFeedBack) {
      let modal = this.modalCtrl.create('QuickTaskPage', { data: data, mode: 'mobile' });
      modal.present({
        keyboardClose: false
      });
      modal.onDidDismiss((openNewTask) => {
        if (openNewTask == true) {
          this.navCtrl.push("NewTaskPage", {
            dataTask: true
          });
        }
      }
      )
    } else {
      this.navCtrl.push('ProfileHomePage', { empid: data.empId, userid: data.userId });
    }
  }

  moreOnboarding() {
    this.navCtrl.push('NewHireDashboardPage');
  }

  // openQuickTask(data) {
  //   if (this.tasknFeedBack) {
  //     let modal = this.modalCtrl.create('QuickTaskPage', { data: data, mode: 'mobile' });
  //     modal.present({
  //       keyboardClose: false
  //     });
  //     modal.onDidDismiss(() => {
  //       }
  //     )
  //   }
  // }

  scrolldah() {
    this.beforeScrollPx = this.afterScrollPx;
    this.afterScrollPx = this.content.scrollTop

    if (this.beforeScrollPx < this.afterScrollPx) {
      this.scrollTopPx = true;
    } else {
      this.scrollTopPx = false;
    }
  }

  async openPage(page: any) {
    this.isDisabled = true;
    //refresh storage
    try {
      this.storage.get('SFGoAuth')
        .then(hasil => {
          const stor = JSON.parse(hasil);

          const updateStorage = stor.updateStorage;
          if (updateStorage != undefined && updateStorage != null) {
            this.SunfishApi.refreshStorage(updateStorage)
              .subscribe(result => {
                if (result.updateStatus == true) {
                  stor.functionAuth = result.functionAuth;
                  stor.updateStorage = new Date();
                  this.storage.set('SFGoAuth', JSON.stringify(stor));
                }
              }, error => {
              })
          }
        }, error => {
        })
    } catch (error) {
    }
    //end of refresh storage
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.component == "leave2Page") {
      this.navCtrl.push(page.component, { empid: this.empId, isProfile: true });
    } else if (page.title == "Attendance") {
      if (!this.isRecordTime) {
        const showBefore = await this.checkPollingBeforeAttendance();
        if (showBefore) {
          this.recordTime();
        }
      }
    } else if (page.title == "Request") {
      this.navCtrl.push('RequestPage', { flag: 0, empid: this.empId, userid: this.SFGoAuth.userId });
    } else {
      this.navCtrl.push(page.component);
    }
  }

  public getstart1() {
    this.getStart1 = true;
    this.getStart2 = false;
    this.getStart3 = true;
  }

  public getstart2() {
    this.getStart1 = true;
    this.getStart2 = true;
    this.getStart3 = false;
  }

  public getstart3() {
    this.getStart1 = true;
    this.getStart2 = true;
    this.getStart3 = true;
    this.overlayStarted = true;
    this.storage.set('FlagStarted', { 'flag': true });
  }

  public hideOverlay(): Promise<any> {
    return new Promise(async (resolve) => {
      if (this.overlayHidden == false) {
        this.overlayHidden = true;
      } else {
        this.overlayHidden = false;
      }
      await this.funcAuth();
      resolve(true);
    })
  }

  goorgChart() {
    this.isDisabled = true;
    if (this.platform.is('tablet') || this.platform.is('core') && this.isHR) {
      this.navCtrl.push('OrgStrEditorPage', { empid: this.empId, status_user: this.statusUser })
    }
  }

  listMember() {
    this.isDisabled = true;
    this.navCtrl.push('ListMemberPage', { empId: this.empId, status_user: this.statusUser });
  }

  addClass(elements, myClass) {

    // if there are no elements, we're done
    if (!elements) { return; }

    // if we have a selector, get the chosen elements
    if (typeof (elements) === 'string') {
      elements = document.querySelectorAll(elements);
    }

    // if we have a single DOM element, make it an array to simplify behavior
    else if (elements.tagName) { elements = [elements]; }

    // add class to all chosen elements
    for (var i = 0; i < elements.length; i++) {

      // if class is not already found
      if ((' ' + elements[i].className + ' ').indexOf(' ' + myClass + ' ') < 0) {

        // add class
        elements[i].className += ' ' + myClass;
      }
    }
  }

  removeClass(elements, myClass) {

    // if there are no elements, we're done
    if (!elements) { return; }

    // if we have a selector, get the chosen elements
    if (typeof (elements) === 'string') {
      elements = document.querySelectorAll(elements);
    }

    // if we have a single DOM element, make it an array to simplify behavior
    else if (elements.tagName) { elements = [elements]; }

    // create pattern to find class name
    var reg = new RegExp('(^| )' + myClass + '($| )', 'g');

    // remove class from all chosen elements
    for (var i = 0; i < elements.length; i++) {
      elements[i].className = elements[i].className.replace(reg, ' ');
    }
  }

  toTicket(items) {
    if (this.selectedTabTask == this.taskList) {
      this.navCtrl.push('TaskDetailPage', {
        ticketId: items.taskCode
      });
    } else {
      this.navCtrl.push('TaskHistoryPage', {
        ticketId: items.taskCode
      });
    }
  }

  gotoProfile() {
    this.navCtrl.push('ProfileHomePage');
  }

  getTeammates(): Promise<any> {
    return new Promise((resolve) => {
      // UPDATE TEAM MATES LIST
      this.subscriptions.push(
        this.homeFeedProvider.getTeamMates(1, this.limitTeammates)
          .subscribe(result => {
            this.skeletonTeam = false;
            this.dummyLocked = false;
            this.teammatesList = result.data;

            if (this.platform.is('cordova')) {
              const date = new Date().toISOString().substr(0, 10).replace(/-/g, '');
              this.storage.set('teammate' + date, JSON.stringify(result.data));
            }

            while (this.teammatesList.length > 5) {
              this.teammatesList.pop();
            }
            resolve(true);
          }, error => {
            this.dummyLocked = true;
            this.skeletonTeam = false;
            if (error.status == '422') {
              this.toggleLocked = true;
              this.showLocked();
            }

            resolve(true);
          })
      );
    })
  }

  getSPV(event) {
    this.currentSPV = event;
  }

  setCommandCount(istotalCommand: number, isIndexCommand: number) {
    if (this.dataFeed[isIndexCommand].post) {
      this.dataFeed[isIndexCommand].post.totalComment = istotalCommand;
    }
  }

  getTodayTask(): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getTodayTask(this.taskPage, this.taskLimit)
        .subscribe(
          async (result) => {
            this.isFix = false;
            this.skeletonTask = false;
            this.taskList = result.data;
            this.selectedTabTask = this.taskList;
            this.storage.set('todayTask', JSON.stringify(this.taskList));
            resolve(true);
          }, error => {
            this.isFix = false;
            this.skeletonTask = false;
            resolve(true);
          }
        )
    })
  }

  toNewTaskPage() {
    // this.navCtrl.push("NewTaskPage");
    let modal = this.modalCtrl.create('NewTaskPage', { isModal: true }, { cssClass: 'grd-modal-mini' });
    modal.present();
  }

  getTodayOwnTask(params = null): Promise<any> {
    return new Promise((resolve) => {
      this.homeFeedProvider.getTodayOwnTask(this.taskPage, this.taskLimit)
        .subscribe((result) => {
          this.taskForPeople = result.data;
          this.isFix = false;
          if (params == 'refresh') {
            this.selectedTabTask = this.taskList;
          } else {
            this.selectedTabTask = this.taskForPeople;
          }
          resolve(true);
        }, error => {
          this.isFix = false;
          resolve(true);
        }
        )
    })
  }

  updateTask(taskCode, newStatusTask, newStatus) {
    this.homeFeedProvider.updateTask(taskCode, newStatusTask, newStatus)
      .subscribe(async (result) => {
        this.currentTask = taskCode;
        if (newStatus == 2) {
          this.isFix = true;
        }

        if (newStatusTask == 2 && this.gamification) {
          this.gamificationProvider.checkAchievement(badgeModule.taskFinisher);
        }

        if (this.selectedTabTask == this.taskList) {
          this.getTodayTask();
        } else if (this.selectedTabTask == this.taskForPeople) {
          this.getTodayOwnTask();
        }
      },
        error => {
        })
  }

  showMenu() {
    this.isShowMenu = !this.isShowMenu;
    this.modalWrapper = this.modalArea.nativeElement;
    if (this.platform.is('ios')) {
      if (this.isShowMenu) {
        this.modalWrapper.style.transform = 'translateY(225px)';
        this.modalWrapper.style.transition = 'all 200ms';
      } else {
        this.modalWrapper.style.transform = 'translateY(110px)';
        this.modalWrapper.style.transition = 'all 200ms';
      }
    }
  }

  toTaskPage() {
    this.navCtrl.push("TaskPage");
  }

  flagCard(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let companyProfile = await this.storage.get('dataCompanyProfile');
        if (companyProfile != null && companyProfile != undefined && companyProfile != "") {
          this.flagCompProfile = companyProfile.flag;
        }

        let companyDetail = await this.storage.get('dataCompanyDetail');
        if (companyDetail != null && companyDetail != undefined && companyDetail != "") {
          this.flagCompDetail = companyDetail.flag;
        }

        let dataProfile = await this.storage.get('dataProfile');
        if (dataProfile != null && dataProfile != undefined && dataProfile != "") {
          this.flagEmp = dataProfile.flag;
        }

        resolve(true);
      } catch (error) {
        resolve(true);
      }
    })
  }

  nextSlide() {
    this.slides.slideNext(500);
  }

  beforeSlide() {
    this.slides.slidePrev(500);
  }

  panEvent(ev): any {
    if (this.content.getContentDimensions().scrollTop < 200) {
      this.totalNewPost = 0;
    }
  }

  /**
   * Load Employee Unix
   */
  loadEmployeeUnix(): any {
    this.subscriptions.push(
      this.tspostserviceApi.getPostEmployee({
        userId: this.SFGoAuth.userId
      }).subscribe(val => {
        /**
         * Realtime
         */
        let object = 'NewPost' + val.unixId + '' + this.SFGoAuth.userId + '' + this.SFGoAuth.companyCode + '' + this.SFGoAuth.companyId;
        this.subscriptions.push(
          this.rt.onReady().subscribe(() => {
            this.rt.IO.on(object).subscribe((msg: any) => {
              this.realTimeRefresh(msg);
            })
          })
        );

      }, error => { })
    );
  }

  /**
   * Realtime Refresher
   */
  realTimeRefresh(msg): any {
    let message = JSON.parse(msg);
    this.paramsDate = message.createddate;
    this.dataFeed.unshift(message);
    this.skipDinamic += 1;
    if (this.content.getContentDimensions().scrollTop > 200) {

      /**
       * Toast Info Post Masuk
       */
      let toast = this.toastCtrl.create({
        message: (this.totalNewPost += 1) + ' new posts',
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  /**
   * Pull Refresher
   */
  doRefresh(refresher) {
    refresher.complete();
  }

  /**
   * Infinite Scroll
   */
  doInfinite(infiniteScroll): any {
    if (!this.infiniteFinish) {
      this.subscriptions.push(
        this.tsfeedserviceApi.getFeed({
          type: 'infinite',
          userId: this.SFGoAuth.userId,
          date: this.paramsDate,
          limit: this.limit,
          skip: this.skipDinamic += this.limit,
          filterType: this.filter.type,
          filterStatus: this.filter.status
        }).subscribe(val => {
          infiniteScroll.complete();

          if (val.length != 0) {
            for (let item of val) {
              this.dataFeed.push(item);
            }
          } else {
            this.skipDinamic -= this.limit;
            this.infiniteFinish = true;
          }
        }, error => {
          this.skipDinamic -= this.limit;
          this.infiniteFinish = true;
          infiniteScroll.complete();
        })
      );
    } else {
      infiniteScroll.complete();
    }
  }
  /**
   * Load Feed by click
   */
  loadFeedFilter(type): any {
    this.subscriptions.push(
      this.tsfeedserviceApi.getFeed({
        userId: this.SFGoAuth.userId,
        limit: this.limit,
        skip: this.skip,
        filterType: this.filter.type,
        filterStatus: this.filter.status
      }).subscribe(val => {
        if (val.length != 0) {
          for (let i = val.length - 1; i >= 0; i--) {
            if (val[i].subType == 'LIST') {
              try {
                val[i].contentDet = JSON.parse(val[i].contentDet).list
              } catch (e) {
              }
            }
          }
          ;
          this.paramsDate = val[0].createddate;
          this.dataFeed = val;
        } else {
          this.dataFeed = [];
          this.dataFeed = this.postEmpty;
        }
        this.isRequest = false;
        this.isLoad = false;
        this.loadingStop(type);
      }, error => {
        this.isRequest = false;
        this.isLoad = false;
        this.loadingStop(type);
      })
    );
  }

  /**
   * To Search Page Employee
   */
  loadSearchEmployee(): any {
    this.isDisabled = true;
    this.navCtrl.push('EmpListPage', { popBack: this.viewCtrl }).then(() => {
      this.isDisabled = false;
    });
  }


  gotour() {
    this.navCtrl.push("GdxGaugePage");
  }

  gotouraaaa() {
    this.navCtrl.push("TestComponentPage");
  }
  /**
   * Request Page
   */
  gotoRequest(fab: FabContainer): any {
    fab.close();
    this.hideOverlay();
    this.navCtrl.push('RequestAll');
  }

  gotoDataCompany() {
    this.isDisabled = true;
    var params = {
      "status": this.statusUser
    }
    this.navCtrl.push('DataCompanyPage', params);
  }

  gotoDataCompanyProfil() {
    var params = {
      "status": this.statusUser
    }
    this.navCtrl.push('DataCompanyProfilePage', params);
  }

  gotoDataStaffProfile() {
    var params = {
      "status": this.statusUser
    }
    this.navCtrl.push('DataStaffProfilePage', params);
  }

  SpvCheck(): Promise<any> {
    return new Promise((resolve) => {
      this.subscriptions.push(
        this.SunfishApi.isSPV()
          .subscribe(result => {
            resolve(result.result);
          }, error => {
            resolve(false);
          })
      )
    })
  }

  async checkDataOnboarding(payload: { type: string }) {
    try {
      await this.homeBloc.dataOnBoarding(payload)
    } catch (error) {
    }
  }

  /**
   * Page Chat
   */
  gotoChat(fab: FabContainer): any {
    this.isDisabled = true;
    fab.close();
    this.hideOverlay();
    this.navCtrl.push('Chat2Page');
  }

  /**
   * Close fab
   */
  close(fab: FabContainer): any {
    // fab.close();
  }

  gotoEvents(fab: FabContainer): any {
    fab.close();
    this.hideOverlay();
    this.navCtrl.push('CalendarNewPage');
  }

  /**
   * Scroll to top
   */
  scrollToTop(): any {
    this.content.scrollToTop();
  }
  closeDropdown() {
    let drop = document.querySelectorAll(".dropmenu");
    this.removeClass(drop, 'drop-active');
    this.isDropmenu = false;
  }

  /** Membuat event window.addEventListener dengan fungsi click */
  @HostListener('document:click', ['$event'])
  onClick(event) {
    let drop = document.querySelectorAll(".dropmenu");
    if (event.target.closest(".dropmenu")) return;

    if (event.target.closest(".box-toggle")) {
      this.isDropmenu = !this.isDropmenu;
      if (this.isDropmenu) {
        this.addClass(drop, 'drop-active');
      } else {
        this.removeClass(drop, 'drop-active');
      }
      return;
    }

    if (this.isDropmenu) {
      this.removeClass(drop, 'drop-active');
      this.isDropmenu = false;
    }
  }

  /** Membuat event window.addEventListener dengan fungsi resize */
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowXsize = window.innerWidth;
    this.windowYsize = window.innerHeight;
    if (window.innerWidth < this.tabletSize) {
      this.isMobile = true;
      this.isTablet = false;
      // ICON MENU CALCULATE
      let widthIcon = 70 * 5;
      if (window.innerWidth < widthIcon) {
        this.decrease = 1;
      } else {
        this.decrease = 0;
      }

      // RESIZE WINDOWS TO ADDPOST WIDTH
      let innerWidth = window.innerWidth;
      this.aPwidth = innerWidth - 36;
      this.aPmaXwidth = innerWidth - 36;
      this.postFxWidth = innerWidth - 96;
      if (!this.isWrapping) {
        this.wrapping();
        this.isWrapping = true;
        this.isUnwrap = false;
      }
    } else if (window.innerWidth >= this.tabletSize && window.innerWidth <= this.tabletProSize) {
      this.isTablet = true;
      this.isMobile = false;
      if (!this.isWrapping) {
        this.wrapping();
        this.isWrapping = true;
        this.isUnwrap = false;
      }
    } else {
      this.isWrapping = false;
      if (!this.isUnwrap) {
        this.unwrap();
        this.isUnwrap = true;
      }
      this.isUnwrap = true;
      this.isMobile = false;
      this.isTablet = false;
      this.aPwidth = '100%';
    }

    // LOGIC ICON MENU HOME MOBILE PHONE SE
    if (window.innerWidth < 359) {
      this.menuCount = 1;
      this.isIphone5 = true;
    } else {
      this.menuCount = 2;
      this.isIphone5 = false;
    }

    this.setSkeletonMenu();
    this.checkFavMenu();

    this.scrollY = this.content.scrollTop;
    if (this.menuService.newHome && this.scrollY < this.showLimit) {
      this.moreFixed = false;
    }
    if (window.innerWidth > 1280) {
      this.slideView = 3
    } else if (window.innerWidth > 767) {
      this.slideView = 2
    } else {
      this.slideView = 1.5
    }
  }

  setSkeletonMenu() {
    if (window.innerWidth < 359) {
      this.isIphone5 = true;
      this.totalMenu = 5;
      this.totalSkeletonMenu = [1, 2, 3, 4];
    } else {
      this.totalMenu = 7;
      this.isIphone5 = false;
      this.totalSkeletonMenu = [1, 2, 3, 4, 5];
    }
  }

  checkFavMenu(): Promise<any> {
    return new Promise(async (resolve) => {

      let favMenus = await this.menuRepository.getFavoriteMenu();

      this.favouriteMenu = [];
      favMenus.forEach(element => {
        if (element.show) {
          this.favouriteMenu.push(element);
        }
      });

      if (this.isIphone5) {
        if (this.favouriteMenu.length > 5) {
          if (this.lastMenu.length < 1) {
            this.lastMenu.push(this.favouriteMenu[this.favouriteMenu.length - 1]);
          }
        }
      } else {
        if (this.favouriteMenu.length > 7) {
          if (this.lastMenu.length < 1) {
            this.lastMenu.push(this.favouriteMenu[this.favouriteMenu.length - 1]);
          }
        }
      }

      resolve(true);
    })
  }

  scrollMe(): any {
    // make sure event updated in real-time using ngZone
    this.ngZone.run(() => {
      if (this.menuService.newHome) {
        // harusnya window.scrollY ??? karena scroll nya bukan di wondows tapi di element DIV
        // this.scrollY = document.getElementById("scroll-home").scrollTop;
        this.scrollY = this.content.scrollTop;
        this.scrollDir = this.scrollY - this.lastScrollY;
        if (window.innerWidth < this.tabletSize) {
          // khusus untuk tampilan mobile

          if (this.scrollY > 71 && this.scrollY < this.showLimit) {
            this.boolChangeClass = true;
            this.moreFixed = false;
            let ukuran = this.aPmaXwidth;
            let a = this.scrollY - 101;
            if (this.scrollY > 101) {
              this.aPwidth = ukuran - a;
            }
          } else if (this.scrollY >= this.showLimit) {
            this.start2show = true;
            this.moreFixed = true;
            this.boolChangeClass = true;
            if (this.aPwidth != this.postFxWidth) {
              this.aPwidth = this.postFxWidth;
            }
          } else if (this.scrollY <= 71) {
            this.boolChangeClass = false;
            this.moreFixed = false;
            if (this.aPwidth != this.aPmaXwidth) {
              this.aPwidth = this.aPmaXwidth;
            }
          }
        } else {
          // desktop & tablet screen view
          this.headerHeight = this.homeHeader.nativeElement.getBoundingClientRect().height;

          let leftSidebarHeight = this.leftSidebar.nativeElement.getBoundingClientRect().height;
          let spacerHeight = this.leftSpacer.nativeElement.getBoundingClientRect().height;
          let spacerOffsetTop = this.leftSpacer.nativeElement.getBoundingClientRect().top;

          if (this.scrollDir > 0) {
            /* scroll ke bawah */
            if (!this.wasScrollDown && this.scrollY <= spacerHeight) {
              this.leftPreSpace = Math.max(this.headerHeight - spacerOffsetTop, 0);
            }

            // activate sticky top
            this.leftSidebarTop = Math.min(window.innerHeight - leftSidebarHeight, this.headerHeight);
            this.leftSidebarBottom = null;

            this.wasScrollDown = true;
          } else if (this.scrollDir < 0) {
            /* scroll ke atas */
            if (this.wasScrollDown && (this.scrollY + window.innerHeight) >= (spacerHeight + leftSidebarHeight + this.scrollY + spacerOffsetTop)) {
              this.leftPreSpace = window.innerHeight - spacerOffsetTop - leftSidebarHeight;
            }

            // activate sticky bottom
            this.leftSidebarTop = null;
            this.leftSidebarBottom = window.innerHeight - leftSidebarHeight - this.headerHeight;

            this.wasScrollDown = false;
          }
          // this.leftSidebarBottom = (scrollDir < 0)? window.innerHeight - this.leftSidebar.nativeElement.getBoundingClientRect().height : null;

          if (this.scrollY > 30) {
            this.headerHd = true;
          } else {
            this.headerHd = false;
          }
        }
        // mark last scroll position
        this.lastScrollY = this.scrollY;
      } else {
        let tScroll = this.content.directionY;
        this.scrollY = this.content.scrollTop;
        if (this.scrollY > 140) {
          this.moreFixed = true;
          if (tScroll == "down") {
            this.boolChangeClass = true;
          } else {
            this.boolChangeClass = false;
          }
        } else {
          this.boolChangeClass = false;
          this.moreFixed = false;
        }
        this.lastScrollY = this.scrollY;
      }
    });
  }

  /**
   * Mencari index array
   */
  findIndexByKeyValue(obj, key, value): any {
    for (let i = 0; i < obj.length; i++) {
      if (obj[i][key] == value) {
        return i;
      }
    }
    return null;
  }

  action() {
    const actionSheet = this.actionSheetCtrl.create({
      title: this.translate.instant('Watch The Tutorial'),
      buttons: [
        {
          text: this.translate.instant('Tutorial Post Feed'),
          handler: () => { }
        }, {
          text: this.translate.instant('Tutorial Write Comment'),
          handler: () => { }
        }, {
          text: this.translate.instant('Tutorial Show Request'),
          handler: () => { }
        }, {
          text: this.translate.instant('Cancel'),
          role: 'cancel',
          handler: () => { }
        }
      ]
    });
    actionSheet.present();
  }

  help() {
    this.action();
  }

  goleave2RequestPage() {
    this.navCtrl.push('leave2RequestPage');
  }

  changeType(type): any {
    if (!this.isRequest && !this.isLoad) {
      this.isRequest = true;
      this.isLoad = true;
      if (this.filter.type != type) {
        this.filter.type = type;
      } else {
        this.filter.type = 'ALL';
      }
      this.loadingStart(type);
      this.loadFeedFilter(type);
    }
  }

  loadingStart(type): any {
    switch (type) {
      case 'REQ':
        this.loadingRun.request = true;
        break;
      case 'PST':
        this.loadingRun.post = true;
        break;
      case 'ALR':
        this.loadingRun.alert = true;
        break;
      case 'CHT':
        this.loadingRun.chats = true;
        break;
      case 'INBOX':
        this.loadingRun.inbox = true;
        break;
      case 'IMPORTANT':
        this.loadingRun.important = true;
        break;
      case 'ARCHIVED':
        this.loadingRun.archived = true;
        break;
    }
    return;
  }

  toggleRespondTask(item) {
    this.selectedTabTask.forEach(element => {
      if (item.taskCode == element.taskCode) {
        item.toggleCheckbox = !item.toggleCheckbox;
      } else {
        element.toggleCheckbox = false;
      }
    });
  }

  toAttendance() {
    if (this.isSF6) {
      this.navCtrl.push("TimeAttendance")
    } else {
      this.navCtrl.push("TimeAttendanceSfgoPage")
    }
  }

  loadingStop(type): any {
    switch (type) {
      case 'REQ':
        this.loadingRun.request = false;
        break;
      case 'PST':
        this.loadingRun.post = false;
        break;
      case 'ALR':
        this.loadingRun.alert = false;
        break;
      case 'CHT':
        this.loadingRun.chats = false;
        break;
      case 'INBOX':
        this.loadingRun.inbox = false;
        break;
      case 'IMPORTANT':
        this.loadingRun.important = false;
        break;
      case 'ARCHIVED':
        this.loadingRun.archived = false;
        break;
    }
    return;
  }

  // segmentChanged(val): any {
  //   if (!this.isRequest && !this.isLoad) {
  //     this.isRequest = true;
  //     this.isLoad = true;
  //     this.filter.status = val.value;
  //     this.loadingStart(val.value);
  //     this.loadFeedFilterNewVersion(val.value);
  //   }
  // }

  funcAuth(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        let hasil = await this.storage.get('SFGoAuth')
        let listMenu = JSON.parse(hasil).menu;
        if (listMenu == undefined) {
          // this.events.publish('user:logout', '')
        } else if (listMenu["att-leave"] || listMenu["att-correction"] || listMenu["att-overtime"] || listMenu["claim"]) {
          this.showRequest = true;
        } else {
          this.showRequest = false
        }
        resolve(true);
      } catch (error) {
        this.showRequest = false;
        resolve(true);
      }
    })
  }

  async getMyCompany(companyId: number): Promise<any> {
    try {
      if (this.SFGoAuth.company.companyName) {
        this.companyName = this.SFGoAuth.company.companyName;
        this.taxCountry = this.SFGoAuth.company.taxcountry;
        this.urlLogo = this.SFGoAuth.company.companyLogo;
        this.storage.set('company', JSON.stringify({
          companyName: this.SFGoAuth.company.companyName,
          taxcountry: this.SFGoAuth.company.taxcountry,
          companyLogo: this.SFGoAuth.company.companyLogo
        }));
      } else {
        this.myCompany = await this.companyBloc.getCompany(companyId);
        this.storage.set('company', JSON.stringify(this.myCompany));
        this.companyName = this.myCompany.companyName;
        this.taxCountry = this.myCompany.taxcountry;
        this.urlLogo = this.myCompany.companyLogo;
      }
    } catch (error) {
      this.myCompany = await this.companyBloc.getCompany(companyId);
      this.storage.set('company', JSON.stringify(this.myCompany));
      this.companyName = this.myCompany.companyName;
      this.taxCountry = this.myCompany.taxcountry;
      this.urlLogo = this.myCompany.companyLogo;
    }
    return;
  }
  /**end */

  /***
   * ******************************************************************************************************************
   * START FEED VERSI BARU
   * ******************************************************************************************************************
   */

  /**
   * Load Feed
   */
  getFeed(skip: number = 0) {
    return new Promise(async (resolve) => {
      try {

        this.isLoadingHome = true;
        this.skeletonFeed = true;

        this.paramsFeed.flag = this.filter.status;
        this.paramsFeed.skip = skip;

        let response = await this.homeBloc.getFeed(this.paramsFeed);
        this.dataFeed = response;
        this.initResouceBooking(this.dataFeed, true);
        this.infiniteFinish = false;

        this.isLoadingHome = false;
        this.skeletonFeed = false;
        this.infiniteLoading = false;
      }
      catch (error) {
        this.isLoadingHome = false;
        this.skeletonFeed = false;
        this.infiniteLoading = false;
        if (error.status === 401) {
          this.logout();
        }
      }
      resolve(true);
    })
  }

  /**
   * Infinite Scroll
   */
  async doInfiniteNewVersion(infiniteScroll: InfiniteScroll) {
    if (!this.infiniteFinish) {
      this.infiniteLoading = true;

      /** handle paging nest api */
      this.paramsFeed.flag = this.filter.status;
      this.paramsFeed.skip += this.paramsFeed.limit;

      let response = await this.homeBloc.getFeed(this.paramsFeed);
      for (let data of response) {
        this.dataFeed.push(data);
      }

      if (response.length == 0) this.infiniteFinish = true;
      if (infiniteScroll) infiniteScroll.complete();
      this.infiniteLoading = false;
    } else {
      if (infiniteScroll) infiniteScroll.complete();
      this.infiniteLoading = false;
    }
  }

  /**
   * Load Feed by click
   */
  loadFeedFilterNewVersion(type): any {
    this.subscriptions.push(
      this.feedServiceApi.getFeed({
        limit: this.limit,
        skip: this.skip,
        flag: this.filter.status
      }).subscribe(val => {
        if (val.length != 0) {
          if (val.data.length != 0) {
            this.dataFeed = [];
            for (let item of val.data) {
              if (item.rel_personal) {
                this.dataFeed.push(item);
              }
            }
          } else {
            this.dataFeed = this.postEmpty;
            this.infiniteFinish = true;
          }
        } else {
          this.dataFeed = [];
          this.dataFeed = this.postEmpty;
          this.infiniteFinish = true;
        }
        this.isRequest = false;
        this.isLoad = false;
        this.loadingStop(type);
      }, error => {
        this.infiniteFinish = true;
        this.isRequest = false;
        this.isLoad = false;
        this.loadingStop(type);
      })
    );
  }

  /***
   * ******************************************************************************************************************
   * END FEED VERSI BARU
   * ******************************************************************************************************************
   */

  async recordTime() {
    this.isRecordTime = true;
    this.isDisabled = true;
    if (this.platform.is('cordova')) {
      this.attendanceBloc.recordAttendance().then(data => {
        if (data) {
          if (typeof data.mockDetect != 'undefined') {
            if (data.mockDetect) {
              this.navCtrl.push("ListBlockPackagePage", {
                packages: data.value
              });
            }
            return false;
          }

          this.redirectAttPreviewPage(data);
        } else {
          this.isRecordTime = false;
          this.isDisabled = false;
        }
      }, () => {
        this.isRecordTime = false;
        this.isDisabled = false;
      });
    } else {
      let setting = await this.attendanceBloc.getAttendanceSetting();
      if (setting.takePhoto) {
        this.navCtrl.push('TimeAttendanceWebcamSfgoPage').then(() => {
          this.navCtrl.getActive().onDidDismiss((data) => {
            if (data !== undefined) {
              this.processWebImage(data);
            } else {
              this.isRecordTime = false;
              this.isDisabled = false;
            }
          })
        })
      } else {
        this.processWebImage();
      }
    }
  }

  async redirectAttPreviewPage(data: AttendancePreviewData) {
    if (this.SFGoAuth.companySetting && this.SFGoAuth.companySetting.covid19Zone) {
      try {
        data.geolocation.latitude = Number(data.geolocation.latitude);
        data.geolocation.longitude = Number(data.geolocation.longitude);
        const attendanceZone = await this.attendanceBloc.covid19ZoneApi(data.geolocation);
        await this.navCtrl.setRoot("AttAlertRedZonePage", { attendanceData: data, attendanceZone: attendanceZone });
      } catch (error) {
        this.nestApiProvider.responseError(error);
      }
    } else {
      this.redirectAttendancePage(data);
    }

    this.isRecordTime = false;
    this.isDisabled = false;
  }

  async redirectAttendancePage(data: AttendancePreviewData) {
    const page = this.isSF6 ? 'TimeAttendancePreviewPage' : 'TimeAttendancePreviewSfgoPage';

    try {
      const companySetting = this.appPreferences.dataAuth && this.appPreferences.dataAuth.companySetting;
      const worklocConfirm = companySetting && companySetting.wlc ? companySetting.wlc : false;

      if (worklocConfirm) {
        const todayForm = await this.appPreferences.getGreatdayStorage(Preference.GDAttendanceTodayForm) as Array<any>;

        const attendanceRedirectPage: AttendanceRedirectPage = {
          page,
          params: { data: data },
          navType: 'push',
          cancelled: false,
          onDidDismiss: false
        }

        if (todayForm && todayForm.length && !this.clockIn) {
          this.navCtrl.push('TimeAttendanceWorklocPage', { attendanceRedirectPage, todayForm });
        } else {
          this.navCtrl.push(page, { data: data });
        }
      } else {
        this.navCtrl.push(page, { data: data });
      }
    } catch (error) {
      this.navCtrl.push(page, { data: data });
    }
  }

  checkAttendance(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        this.onload = true;
        let result = await this.attendanceBloc.getTodayAttendance();
        if (result.success) {
          this.onload = false;
          this.clockIn = result.result.starttime;
          this.clockOut = result.result.endtime;
          this.actualClockIn = result.result.actualIn;
          this.actualClockOut = result.result.actualOut;
          this.feedBack = result.result.feedback;

          if (this.feedBack !== null && this.feedBack !== undefined) {
            this.storage.get('rating').then(data => {
              if (data == null || data == undefined) {
                this.showRating();
              }
            })
          }
        }
        resolve(true);
      } catch (error) {
        this.onload = false
        this.getRefreshToken(error)
        resolve(true);
      }
    })
  }

  processWebImage(event?: any) {
    this.attendanceBloc.processWebImage(event).then(data => {
      if (data) {
        this.redirectAttPreviewPage(data);
      }
    })
  }

  async loadRequestBadge(): Promise<any> {
    return new Promise(async (resolve) => {
      await this.loadCountMyApprovalNew();
      await this.loadCountMyRequestNew();
      resolve(true);
    })
  }

  /** GET COUNT APPROVAL WITH NEW API NEST JS */
  loadCountMyApprovalNew(): Promise<any> {
    return new Promise(async (resolve) => {
      const payload = {
        'userId': this.SFGoAuth.userId
      }

      this.subscriptions.push(
        this.requestInboxApi.countMyApproval(payload).subscribe(val => {
          this.requestBadge.approval = val.data;
          resolve(true);
        }, error => {
          resolve(true);
        })
      );
    })
  }

  /** GET COUNT REQUEST WITH NEW API NEST JS */
  loadCountMyRequestNew(): Promise<any> {
    return new Promise(async (resolve) => {
      const payload = {
        'userId': this.SFGoAuth.userId,
        'isSF6': this.isSF6
      }

      this.subscriptions.push(
        this.requestInboxApi.countMyRequest(payload).subscribe(val => {
          this.requestBadge.request = val.data;
          resolve(true);
        }, error => {
          resolve(true);
        })
      );
    })
  }

  loadBrowser() {
    let url = ''
    switch (this.languageSelected) {
      case "id":
        url = "https://greatdayhr.com/blog/2018/12/10/greatday-hr-do-something-great-every-day/?lang=id";
        break;
      default:
        url = "https://greatdayhr.com/blog/2018/12/07/greatdayhr-do-something-great-every-day/";
        break;
    }
    const browser = this.iab.create(url, '_blank', 'location=yes');
    browser.show();
  }

  detectBottom() {
    if (this.content._scroll && !this.isScroll) {
      this.isScroll = true
      setTimeout(() => {
        this.isScroll = false
      }, 2000)
    }
  }

  survey() {
    this.isDisabled = true;
    this.storage.get('SFGoAuth')
      .then(async (hasil) => {
        const SFGoAuth = JSON.parse(hasil);
        const params: any = {
          name: SFGoAuth.fullName,
          email: SFGoAuth.email,
          company: SFGoAuth.multiCompany.company_list[0].company_name || '',
          position: SFGoAuth.position,
          companyCode: SFGoAuth.companyCodes,
          authorization: SFGoAuth.id
        }

        if (this.platform.is('cordova')) {
          params.surveyFrom = 'mobileApp'
        } else {
          params.surveyFrom = 'webApp'
        }

        let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
        const opt: InAppBrowserOptions = {
          "location": "no",
          "clearcache": "yes",
        }

        const browser = this.inAppBrowser.create('https://sfsupport.dataon.com/survey-greatday?' + queryString, '_blank', opt);

        if (this.platform.is('cordova')) {
          browser.on('loadstart').subscribe(() => {
            this.isDisabled = false;
          });

          browser.on("loadstop").subscribe(result => {
            let loop = setInterval(() => {
              browser.executeScript({
                code: "localStorage.getItem('surveyProcess')"
              }).then(values => {
                if (values[0] === 'finish') {
                  browser.executeScript({ code: "localStorage.setItem('surveyProcess','');" });
                  clearInterval(loop);
                  browser.close();
                }
              })
            }, 2000);
          })
        }
      })
  }

  unwrap(): Promise<any> {
    return new Promise((resolve) => {
      let wrapper = document.querySelector('.content-section');

      // place childNodes in document fragment
      let docFrag = document.createDocumentFragment();
      if (wrapper) {
        while (wrapper.firstChild) {
          let child = wrapper.removeChild(wrapper.firstChild);
          docFrag.appendChild(child);
        }
      }

      try {
        // replace wrapper with document fragment
        wrapper.parentNode.replaceChild(docFrag, wrapper);
      }
      catch (error) {
      }

      resolve(true);
    })
  }

  wrapping() {
    let element = document.querySelector('.holder-box');
    let element2 = document.querySelector('.today-teammates-wrapper');
    let element3 = document.querySelector('.right-sidebar');
    let element4 = document.querySelector('.feed-wrapper');
    let parent = element.parentNode;
    // `element` is the element you want to wrap
    let wrapper = document.createElement('div');
    wrapper.className = "content-section";
    // set the wrapper as child (instead of the element)
    parent.replaceChild(wrapper, element);
    parent.replaceChild(wrapper, element2);
    parent.replaceChild(wrapper, element3);
    parent.replaceChild(wrapper, element4);
    // set element as child of wrapper
    wrapper.appendChild(element);
    wrapper.appendChild(element2);
    wrapper.appendChild(element3);
    wrapper.appendChild(element4);
    this.modalWrapper = wrapper;
    // this.isWrapping = false;
  }

  /** set banner danafix is show or not */
  setBannerShow(listMenu): Promise<any> {
    return new Promise((resolve) => {
      if (listMenu["flexible-benefit-payadvance"]) {
        this.isBannerDanafix = true;
      }
      resolve(true);
    })
  }

  /** function for danafix banner click event with analytics */
  async danafix() {
    try {
      //GA
      this.storage.remove("payAdvanceGAType");
      this.storage.set("payAdvanceGAType", "Banner");

      const danafixProvider = await this.getDanafixProvider();

      let data = {
        packageSelected: {
          'id': danafixProvider.id,
          'partnerId': danafixProvider.partnerId
        }
      }

      this.navCtrl.push("DanafixInputLoanPage", data);
    } catch (err) {
      const message = (typeof err === 'string') ? err : JSON.stringify(err);
      this.alertService.createMola(message);
    }
  }

  /** function for get danafix provider */
  getDanafixProvider(): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        this.payDayLoanServiceApi.getRequest('getPaydayProvider', {}).subscribe((res: any[]) => {
          const filterRes = res.filter(item => {
            return item.partnerId === 12;
          });

          if (filterRes.length) {
            resolve(filterRes[0]);
          } else {
            reject('Danafix provider not found');
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  benefit() {
    this.navCtrl.push("SurveyEmployeeBenefitPage");
  }

  menuClick(data) {
    if (data.pageStatic === "covid19") {
      this.goToCovid19()
    }
    else if (data.pageStatic == 'yesdok') {
      this.goToYesdok()
    } else {
      data.typeMenu = 'push';
      this.events.publish('user:openPage', data);
    }
  }

  PostModal() {
    let modal = this.modalCtrl.create('PostModalPage');
    modal.present();
  }

  transitionLayout() {
    this.navCtrl.push("ProgressbarPage").then(() => {
      this.setTheme();
      this.initDynamicData();
      if (this.SFGoAuth.isSF6) this.events.publish('company:loadmultiplecompany', true);

      this.navCtrl.getActive().onDidDismiss(() => {
        this.openGuide();
        this.menuCtrl.enable(true);
      })
    })
  }

  async setTheme() {
    this.scrollY = this.content.scrollTop;
    if (!this.menuService.newHome && this.scrollY < this.showLimit) {
      this.moreFixed = false;
    }
    this.menuService.newHome = !this.menuService.newHome;
    try {
      await this.storage.set("new-theme", this.menuService.newHome);
    }
    catch (error) { }
    this.initView();
    this.events.publish('toggleLayout');

    if (!this.menuService.newHome) {
      this.menuCtrl.swipeEnable(true);
    }
  }

  showRating() {
    if (this.showRatingCount == 1) {
      let modal = this.modalCtrl.create("RatingModalPage", {}, {
        cssClass: "grd-modal-rating",
        showBackdrop: true,
        enableBackdropDismiss: true
      });
      modal.present();
      this.showRatingCount++;
    }
  }

  getAnnouncement(): Promise<any> {
    return new Promise(async (resolve) => {
      if (this.SFGoAuth.isSF6) {
        await this.getAnnouncementSF6();
      }
      else {
        await this.getAnnoucementGD();
      }
      resolve(true);
    })
  }

  getAnnoucementGD() {
    return new Promise((resolve) => {
      this.skeletonCompany = true;
      this.announcementProvider.getAnnouncement(this.formDataAnnouncement.page, this.formDataAnnouncement.limit)
        .subscribe((result) => {
          this.skeletonCompany = false;
          let now = moment(new Date()); //todays date
          let index = 0;

          if (result.data.length > 0) {
            let temporary = [];
            for (let item of result.data) {
              if (index < 3) {
                let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
                item.createdDate.duration = duration;
                item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
                temporary.push(item);
              }
              index++;
            }
            this.dataAnnouncement = temporary;
          }
          this.storage.set('announcement', JSON.stringify(this.dataAnnouncement));
          resolve(true)
        }, error => {
          this.skeletonCompany = false;
          resolve(true);
        })
    })
  }

  getAnnouncementSF6() {
    return new Promise(async (resolve) => {
      const route = "ofid=CompanyGD.listingAnnouncement";
      const params = [{
        paramKey: "limit",
        paramValue: 3
      },
      {
        paramKey: "page",
        paramValue: 1
      },
      {
        paramKey: "lang",
        paramValue: this.language || 'en'
      }]

      try {
        this.skeletonCompany = true;
        const result = await this.pageBuilderGlobal.cfcDirectApi(route, params);
        this.skeletonCompany = false;
        let now = moment(new Date()); //todays date
        let index = 0;

        if (result.data.length > 0) {
          let temporary = [];
          for (let item of result.data) {
            if (index < 3) {
              let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
              item.createdDate.duration = duration;
              item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
              temporary.push(item);
            }
            index++;
          }
          this.dataAnnouncement = temporary;
        }
        this.storage.set('announcement', JSON.stringify(this.dataAnnouncement));
      }
      catch (error) {
        this.skeletonCompany = false;
      }

      this.skeletonCompany = false;

      resolve(true)
    })
  }

  toInfoDetail(item) {
    this.featurePageProvider.getPageFeatureByCode('HOME.ANNOUNCEMENT').then(page => {
      let pageId = page.pageId;
      if (pageId) {
        this.openPageBuilder(pageId, item);
      } else {
        this.navCtrl.push('DetailAnnouncement', { announcementHome: item, url: this.urlLogo });
      }
    });
  }

  toLeaderboard() {
    this.navCtrl.push("LeaderboardPage");
  }

  async getMyScore() {
    try {
      const payload = {
        companyId: this.SFGoAuth.companyId,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        empId: this.SFGoAuth.empId
      }

      let myScoreData = await this.homeBloc.getMyScore(payload)
      if (myScoreData.length <= 0) {
        this.myScore = 0
      } else {
        this.myScore = myScoreData[0].totalLike
      }
    } catch (error) {
    }
  }

  toProfile() {
    this.navCtrl.push("ProfileHomePage");
  }

  async takeAction(item) {
    // Close Dropdown Profile
    this.closeDropdown();

    // Click Target
    if (item == 'Logout') {
      this.logout();
    } else if (item == 'Profile') {
      this.toProfile()
    } else if (item == 'Setting') {
      this.navCtrl.push("SettingPage");
    } else if (item == 'Support') {
      this.chatSupportService.showChat();
    }
  }

  logout() {
    this.events.publish('user:logout');
  }

  async onChange(value) {
    this.translate.use(value);
    await this.storage.set('language', value);
    this.language = value;

    this.languageSelected = value;
    if (this.languageSelected == 'en') {
      this.languageSelected2 = 'English'
    } else if (this.languageSelected == 'id') {
      this.languageSelected2 = 'Indonesia'
    } else if (this.languageSelected == 'th') {
      this.languageSelected2 = 'Thailand'
    } else if (this.languageSelected == 'cn') {
      this.languageSelected2 = 'Chinese'
    } else if (this.languageSelected == 'kr') {
      this.languageSelected2 = 'Korean'
    } else if (this.languageSelected == 'jp') {
      this.languageSelected2 = 'Japanese'
    } else if (this.languageSelected == 'my') {
      this.languageSelected2 = 'Malaysia'
    }

    this.events.publish('language:change');
  }

  // This code is Disabled, confirm Fattah UI/UX for more information
  openGuide(): Promise<any> {
    return new Promise(async (resolve) => {
      if (this.platform.is('cordova')) {
        let data = localStorage.getItem('guide');
        // let data;
        if (data == null && data == undefined && this.menuService.newHome) {
          const modal = this.modalCtrl.create(
            'ModaltourPage', {},
            {
              cssClass: 'grd-modal-rating'
            }
          );

          let steps = [];
          try {
            let auth = await this.storage.get('SFGoAuth');
            let listMenu = JSON.parse(auth).menu;

            steps.push({
              element: '#step1',
              intro: this.translate.instant("Access GreatDay HR menus here"),
              position: 'bottom',
            });

            steps.push({
              element: '#step2',
              intro: this.translate.instant("You can set up your company data and setting here. it will disappear when you have finished configurin your company"),
              position: 'bottom',
            });

            if (listMenu["team-mates"]) {
              steps.push({
                element: `#step3`,
                intro: this.translate.instant("View your team’s attendance here"),
                position: 'bottom',
              });
            }

            if (listMenu["task"]) {
              steps.push({
                element: `#step4`,
                intro: this.translate.instant("Assign task here"),
                position: 'top',
              });
            }

            steps.push({
              element: `#step5`,
              intro: this.translate.instant("ini Feed"),
              position: 'top',
            });

            steps.push({
              element: `#step6`,
              intro: this.translate.instant("Tap ‘More’ for more features"),
              position: 'bottom',
            });

          } catch (error) {
            steps = []
          }
          localStorage.setItem("guide", "1");

          modal.onDidDismiss(() => {
            const intro = this.appGuideProviders.homeGuide(steps)

            setTimeout(() => {
              intro.start();
            }, 300);

            intro.oncomplete(() => {
              this.appGuideProviders.isRunTourGuide = false;
              localStorage.setItem("guide", "1");
            });

            intro.onexit(() => {
              this.appGuideProviders.isRunTourGuide = false;
              localStorage.setItem("guide", "1");
            });
          })
          modal.present();
        }
      }

      resolve(true);
    })
  }

  getSPVDetail(event) {
    this.spvDetail = event;
  }

  async chatSpv() {
    this.loadingService.presentLoadingDefault();

    let personal = null;
    let salutation = '';

    let criteria = {
      employeeId: this.spvDetail.empId
    }

    try {
      personal = await this.getPersonalInfo(criteria.employeeId);
      salutation = personal.data[0].salutation_name || '';
    }
    catch (error) {
    }

    this.chatServiceProvider.createRooms("personal", criteria).subscribe(results => {
      let roomId = (results['data']['id']) ? results['data']['id'] : results['data'];
      this.socketIoClientProvider.emit('room-join', roomId);
      this.loadingService.dismissLoading();

      this.navCtrl.push("ChatPersonalPage", {
        roomId: roomId,
        employee: this.spvDetail,
        chatType: 'personal',
        message: `${this.translate.instant('Hi')} ${salutation}, ${this.translate.instant('is there any tasks I can do today?')} 😀`
      });

    }, (error: HttpErrorResponse) => {
      this.loadingService.dismissLoading();
      this.nestResponses.error(error);
    })
  }

  getPersonalInfo(empId): Promise<Paginate<Personal>> {
    return new Promise((resolve, reject) => {
      let data;
      if (this.storedPrelogin.hasOwnProperty('GOPATHNEW')) {
        this.personalNestApi.getPersonal(empId)
          .subscribe(
            async (result) => {
              data = await this.globalService.convertObjToCamelCase(result.data);
              if (empId === this.SFGoAuth.empId) {
                this.nickname = data.initialName;
                this.firstname = data.firstName;
              }
              resolve(data);
            },
            error => {
              reject(false)
              console.log(error)
            }
          )
      } else {
        this.personalApi.getPersonal(empId).subscribe(
          async (result: Paginate<Personal>) => {
            data = await this.globalService.convertObjToCamelCase(result.data[0]);
            if (empId === this.SFGoAuth.empId) {
              this.nickname = data.initialName;
              this.firstname = data.firstName;
            }
            resolve(result)
          }, error => {
            reject(false)
          })
      }
    })
  }

  gomcomp() {
    const modal = this.modalCtrl.create(
      'MultiCompanyPage', { companyList: this.companyList, companySelected: this.companySelected },
      {
        cssClass: 'grd-modal-rating'
      }
    );

    modal.onDidDismiss((response) => {
      if (response) {
        this.changeCompany(response.companyId);
      }
    })
    modal.present();
  }

  /**
  * Page Post
  */
  gotoPost(fab, data?: any): any {
    let addPostModal = this.modalCtrl.create('PostPages', {
      openAttachment: fab,
      top: this.topPost,
      left: this.leftPost,
      width: this.widthPost,
      widthMobile: this.aPwidth,
      paramsEdit: data
    }, {
      cssClass: "grd-modal-noanimation",
      showBackdrop: true,
      enableBackdropDismiss: true
    });

    addPostModal.onDidDismiss((data) => {
      if (data && data != 'close') {
        this.addPosting(data);
      }
    })

    addPostModal.present({
      keyboardClose: false,
    });
  }

  async addPosting(params: addPostingParams) {
    /** 1. listen progress upload and send posting */
    this.homeBloc.subscriptions.push(this.homeBloc.isSendPost.subscribe((val) => { this.isSendPost = val }));
    this.homeBloc.subscriptions.push(this.homeBloc.uploadPostDone.subscribe((val) => { this.uploadPostDone = val }));

    /** 2. tambahan parameter */
    params.accessToken = this.SFGoAuth.id;
    params.empphotopath = this.empphotopath;

    /** 3. save post  */
    const savePost = await this.homeBloc.addPosting(params);

    /** 4. set to default define */
    this.isSendPost = false;
    this.uploadPostDone = true;

    /** 5. reload feed if save post/feed success */
    if (savePost) {
      /** handle supaya gak kena caching data back end */
      setTimeout(() => {
        this.getFeed();
      }, 1000)
    }
  }

  setMore(): Promise<any> {
    return new Promise((resolve) => {
      localStorage.setItem("isMoore", "1");
      resolve(true);
    })
  }

  getMore(): Promise<any> {
    return new Promise((resolve) => {
      let data = localStorage.getItem('isMoore');
      if (data == null && data == undefined) {
        this.isMoore = true;
      } else {
        this.isMoore = false;
      }
      resolve(true);
    })
  }

  /** Check Attendance Offline Data */
  async checkAttOfflineData() {
    try {
      this.toggleSnackbar = false;
      const attOffline = await this.storage.get('SFGoAttendanceLog');
      if (attOffline != null && attOffline != undefined) {
        this.toggleSnackbar = true;
        this.attOfflineList = JSON.parse(attOffline).reverse();
      }
      else {
        this.attOfflineList = [];
        this.toggleSnackbar = false;
      }
    }
    catch (error) {
      this.attOfflineList = [];
      this.toggleSnackbar = false;
    }
  }

  closeSnackbar() {
    this.toggleSnackbar = false;
  }

  toOfflineList() {
    let modal = this.modalCtrl.create('OfflineModeListPage', { mode: 'modal' }, { cssClass: "gd-modal-radius" });

    modal.onDidDismiss(() => {
      if (!this.isSyncAttendance) {
        this.checkAttOfflineData();
      }
    })
    modal.present();
  }

  sendRecordsOfflineAtt() {
    this.toggleSnackbar = false;
    this.events.publish('OFFLINEMODE:RUNSYNCATTENDANCEOFFLINERECORD', false);
  }

  async alertpls() {
    const alert = this.alertCtrl.create({
      cssClass: 'invalidtkn',
      message: `
      <img src="assets/images/invalid-token.png" width="40%" height="40%" />
      <h3>Access Token Invalid</h3>
      <h6>Upssss, sorry looks like you have to refresh your session to keep using GreatDay</h6>
      `,
      buttons: [
        {
          text: 'Refresh Session',
          handler: () => {
          }
        },
        // {
        //   text: 'oke',
        //   handler: () =>{}
        // }
      ]
    });
    alert.present();
  }

  openpls1() {
    this.alertService.invalidtoken();
  }

  async getRefreshToken(error) {
    if (error instanceof HttpErrorResponse) {
      let invalidToken = false;
      try {
        invalidToken = error.error.message.includes("Invalid access token");
      } catch (error) { }
      if (error.status == 401 && invalidToken) {
        if (this.storedPrelogin.hasOwnProperty('GOPATHNEW')) {
          const SFGoAuth = await this.appPreferences.getAuth();
          if (SFGoAuth.hasOwnProperty('refreshToken')) {
            const refreshToken = SFGoAuth.refreshToken;
            if (refreshToken) {
              await this.presentAlertRefreshToken(true);
              const loading = this.loadingCtrl.create({});
              loading.present();

              const loadSass = await this.authenticationBloc.loadAuth(true);
              loading.dismiss();

              if (loadSass.forceLogout) {
                this.events.publish('user:logout', true);
              }
              else {
                this.navCtrl.setRoot("Home2Page");
              }
            }
            else {
              await this.presentAlertRefreshToken(false);
              this.events.publish('user:logout', '');
            }
          } else {
            await this.presentAlertRefreshToken(false);
            this.events.publish('user:logout', '');
          }
        }
      }
    }
  }

  async presentAlertRefreshToken(refresh: boolean) {
    return new Promise((resolve) => {
      const alert = this.alertCtrl.create({
        cssClass: 'invalidtkn',
        enableBackdropDismiss: false,
        message: `
        <img src="assets/images/invalid-token.png" width="40%" height="40%" />
        <h3>${Messages.INVALID_TOKEN}</h3>
        <h6>${(refresh) ? this.translate.instant(Messages.MSG_REFRESH_SESSION) : this.translate.instant(Messages.MSG_EXPIRED_SESSION)}</h6>
        `,
        buttons: [
          {
            text: (refresh) ? this.translate.instant('Refresh Session') : this.translate.instant('Logout'),
            handler: () => {
              resolve(true);
            }
          }
        ]
      });
      alert.present();
    })
  }

  userfeed() {
    let modal = this.modalCtrl.create('ProblemFormPage', {
      cssClass: "grd-modal-noanimation",
      showBackdrop: true,
      enableBackdropDismiss: true
    });
    modal.present({
    });
  }

  steper() {
    // this.navCtrl.push("UserFeedback2Page");
    // this.alertService.loginErorMessage();
  }

  getUnreadChat() {
    this.subscriptions.push(
      this.chatServiceProvider.getUnreadMsg()
        .subscribe((result) => {
          try {
            this.unreadChat = result.data;
            this.chatServiceProvider.setUnreadCount = this.unreadChat;
            this.events.publish('chat:unreadCount', this.chatServiceProvider.getUnreadCount);
          }
          catch (error) {
            console.log(error)
          }
        }, error => {
          console.log(error)
        })
    )
  }

  async updateSubscriptionCredit(): Promise<any> {
    if (this.SFGoAuth.isHRAdmin) {
      await this.homeBloc.updateSubscriptionDashboard().catch();
    }
  }

  async announcementEmergency() {
    try {
      const global = await this.storage.get("globalAnnouncement");
      if (global) {
        if (global.show) {
          this.showNotif = true;
          this.emergencyAnnoucement = global;
        } else {
          this.showNotif = false;
        }
      } else {
        this.showNotif = false;
      }
    } catch (error) {
      this.showNotif = false;
    }
  }

  getYesdokNotification() {
    if (this.navParams.get('isNotifYesdok')) {
      this.goToYesdok()
    }
    if (this.navParams.get('isNotifYesdokCovid19')) {
      this.goToCovid19();
    }
  }

  goToYesdok() {
    const txt = this.translate.instant("Layanan ini didukung oleh YesDok<br><br>GreatDay HR akan membagikan data diri Anda kepada YesDok sebatas untuk pembuatan akun. Anda akan otomatis terdaftar sebagai pengguna YesDok dengan <a style='font-weight:bold;' class='termYesdok'>syarat & ketentuan</a> yang berlaku.");
    this.alertService.ConfirmYesdok(txt).then(isConfirm => {
      if (isConfirm) {
        this.yesdokService.getYesdokUrl({ route: "Business/Consultation" }).subscribe(resp => {
          if (resp.data.url) {
            this.iab.create(resp.data.url, '_system', 'location=yes')
          } else {
            this.alertService.createMola(resp.message)
          }
        }, error => {
          this.nestResponses.error(error);
        })
      }
    })
  }
  @HostListener('window:click', ['$event'])
  onClickYesdok(e) {
    if (e.target.className == 'termYesdok activated') {
      this.iab.create('https://www.yesdok.com/id/tnc.html', '_blank')
    }
  }
  goToCovid19() {
    let isConsult = false;
    this.alertService.ConfirmYesdok("Layanan ini didukung oleh YesDok<br><br>GreatDay HR akan membagikan data diri Anda kepada YesDok sebatas untuk pembuatan akun. Anda akan otomatis terdaftar sebagai pengguna YesDok dengan <a style='font-weight:bold;' href='https://www.yesdok.com/id/tnc.html'>syarat & ketentuan</a> yang berlaku.").then(res => {
      if (res) {
        this.yesDokServiceApi.getRequest({
          route: "User/Covid"
        }).timeout(60 * 2 * 1000).subscribe(resp => {
          if (resp.Code === 101) {
            this.partnerCovid = resp.Data.Url.substring(resp.Data.Url.indexOf("partner=") + 8, resp.Data.Url.length)
            let browser = this.inAppBrowser.create(resp.Data.Url, '_blank', 'location=yes')
            if (this.platform.is("cordova")) {
              let loop = setInterval(() => {
                this.yesDokServiceApi.getRequest({
                  route: "checkCallback",
                  partner: this.partnerCovid
                }).subscribe(resp => {
                  if (resp.action == "close") {
                    browser.close();
                    clearInterval(loop)
                  }
                  else if (resp.action == "call" && !isConsult) {
                    clearInterval(loop)
                    isConsult = true
                    this.goConsult(browser);
                  }
                })
              }, 4000)
              browser.on("exit").subscribe(resp => {
                console.log(resp)
                clearInterval(loop)
              })
            }
          }
          else {
            this.alertService.createMola(resp.Msg)
          }
        })
      }
    })
  }
  goConsult(brows) {
    let clear = false;
    let tempTimer = setTimeout(() => {
      if (clear) {
        clearTimeout(tempTimer)
      } else {
        brows.close()
        clearTimeout(tempTimer)
      }
    }, 15000)
    this.yesDokServiceApi.getRequest({
      route: "User/Consultation",
      partner: this.partnerCovid
    }).subscribe(async resp => {
      clear = true;
      brows.close()
      if (resp.Code === 101 || resp.Code === 201) {
        if (this.platform.is("cordova")) {
          this.inAppBrowser.create(resp.Data.Url, '_system', 'location=yes')
        }
      }
      else {
        this.alertService.createMola(resp.Msg)
      }
      // if(this.platform.is("ios")){
      //   if(resp.Code === 101 || resp.Code === 201){
      //     let browser = this.inAppBrowser.create(resp.Data.Url, '_system', 'location=yes')
      //   }
      // }
      // else if(this.platform.is("cordova")){
      //   if(resp.Code === 101 || resp.Code === 201){
      //     // await this.permissionCheckProvider.getGeolocation()
      //     // await this.permissionCheckProvider.getCameraPermission()
      //     // await this.permissionCheckProvider.getAudioPermission()
      //     let browser = this.inAppBrowser.create(resp.Data.Url, '_system', 'location=yes')
      //   }
      // }
    }, err => {
      clear = true;
      brows.close()
      this.alertService.createMola("There is Something Wrong")
    })
  }

  goAttendance() {
    this.navCtrl.push("OfflineModeIndexPage");
  }

  async checkPollingAfterLogin() {
    const result = await this.homeBloc.checkPollingAfterLogin();
    if (result.page) {
      const type = result.restrict ? 'setRoot' : 'push';
      this.navigationService.openPage(result.page, result.params, type);
    }
  }

  async checkPollingBeforeAttendance(): Promise<boolean> {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    let next = true;
    if (arrayPoll) {
      const idx = arrayPoll.findIndex(i => i.prompt == 'before_attendance');
      if (idx != -1) {
        const poll = arrayPoll[idx];
        if (poll && poll.prompt == 'before_attendance') {
          next = false;
          if (poll.restrict) {
            this.navCtrl.setRoot("PollingWelcomePage", poll);
          } else {
            this.navCtrl.push("PollingWelcomePage", poll).then(() => {
              this.navCtrl.getActive().onDidDismiss(data => {
                this.setStorage(poll.surveyCode);
              });
            });
          }
        }
      }
    }
    return next;
  }

  async checkPollingAfterAttendance() {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    if (arrayPoll) {
      const idx = arrayPoll.findIndex(i => i.prompt == 'after_attendance');
      if (idx != -1) {
        const poll = arrayPoll[idx];
        if (poll && poll.prompt == 'after_attendance') {
          if (poll.restrict) {
            await this.navCtrl.setRoot("PollingWelcomePage", poll);
          } else {
            await this.navCtrl.push("PollingWelcomePage", poll);
          }
        }
      }
    }
  }

  async setStorage(surveyCode: any) {
    const arrayPoll = await this.pollingBloc.getPollingFromStorage();
    const idx = arrayPoll.findIndex(i => i.surveyCode == surveyCode);
    if (idx != -1) {
      arrayPoll.splice(idx, 1);
      await this.pollingBloc.setPollingToStorage(arrayPoll);
    }
  }

  gotoPanicButton() {
    this.navCtrl.push("PanicButtonPage");
  }

  panicPanGesture() {
    let panic = document.getElementById('panic');
    if (panic) {
      let mc = new window['Hammer'](panic);
      mc.add(new window['Hammer'].Pan({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 }));
      mc.on('pan', (ev) => {
        this.sosPosition.top = (ev.srcEvent.clientY - (panic.clientHeight / 2)) + 'px';
      })
    }
  }

  async processResourceBooking(action, params) {
    try {
      if (action == 'close') {
        if (params.isButtonStart) {
          const confirm = await this.alertService.confirmMola('Do you want to cancel booking?', 'No', 'Cancel Booking');
          if (confirm) {
            const confirm2 = await this.alertService.confirmMola('Are you sure want cancel resource booking?', 'No', 'Yes');
            if (confirm2) {
              let res = await this.homeBloc.processResourceBooking('cancel', params);
              this.alertService.createMola(res.message).then(() => {
                this.toggleResourceBook = false;
              });
            } else {
              await this.homeBloc.processResourceBooking(action, params);
              this.toggleResourceBook = false;
            }

          } else {
            await this.homeBloc.processResourceBooking(action, params);
            this.toggleResourceBook = false;
          }
        } else {
          await this.homeBloc.processResourceBooking(action, params);
          this.toggleResourceBook = false;
        }
      } else {
        let res = await this.homeBloc.processResourceBooking(action, params);
        this.alertService.createMola(res.message).then(() => {
          this.toggleResourceBook = false;
        });
      }
      await this.getFeed();
    } catch (err) {

      this.toggleResourceBook = false;
    }
  }

  initResouceBooking(data, isFirst) {
    try {
      const bookData = data.filter(item => {
        return item.type === 'BOK';
      });
      const bookDataDet = bookData.filter(item2 => {
        return JSON.parse(item2.smartFeed.contentDetail).isFirst === isFirst;
      });
      if (bookDataDet.length > 0) {
        this.toggleResourceBook = true;
        this.dataResourceBook = JSON.parse(bookDataDet[0].smartFeed.contentDetail);
        this.dataResourceBook['feed_id'] = bookDataDet[0].id;
      } else {
        this.toggleResourceBook = false;
        this.dataResourceBook = {};
      }
    } catch (err) {
      this.toggleResourceBook = false;
      this.dataResourceBook = {};
    }

  }

  switchLang() {
    this.authenticationBloc.switchLanguage(this.language);
  }

  async loadOnBoarding() {
    try {
      if (this.showMyonboarding) {
        const result = await this.onBoardingBloc.getOnBoardingData();
        this.onBoardProgress = result.totalAllPercentage;
      }
    } catch (e) {

    }
  }

  async getBadgeOnAvatar() {
    try {
      const badge: any = await this.homeBloc.getBadgeOnAvatar(this.SFGoAuth.empId);
      this.myBadge = badge ? this.gamificationProvider.assignImage(badge.tgospgmfmbadge.name, 'circle') : '';
      this.homeBloc.setMyBadge(this.myBadge);
    } catch (error) { }
  }

  showAttendanceAfterSurvey() {
    const isShow = this.navParams.get('openAttendance');
    if (isShow) {
      this.recordTime();
    }
  }

  async switchAccountReload(data: SwitchAccountResponse) {
    try {
      // load auth
      const auth = await this.authenticationBloc.loadAuthSwitchAccount();

      // publish event get menu pagebuilder
      this.events.publish('user:created', auth);
      if (this.platform.is('android')) {
        await this.initializeBloc.getWhiteList();
        await this.initializeBloc.sendIndicatedMock();
      }

      if (this.platform.is('cordova')) {
        this.globalService.splashScreenDownload();
      }

      await this.attendanceBloc.findAttWorkLocation();
      await this.multipleAccountBloc.updateStorageMultipleAccount(data);
      await this.multipleAccountBloc.fcmRegisterToken(data.accountToSwitch);

      this.events.publish('multiaccount:switchdone');
      this.navCtrl.setRoot("Home2Page");
    } catch (error) {
      this.events.publish('multiaccount:switchdone');
      this.multipleAccountBloc.rollBackSwitchAccount(data);
      this.attendanceBloc.nestApiProvider.responseError(error);
    }
  }

  emulateProgress() {
    return new Observable<number>(observer => {
      let startValue = 0;
      const value = 20
      setInterval(() => {
        if (startValue < value) {
          startValue++;
        }

        observer.next(startValue);
      }, 15);
    });
  }

  goSetupCompany() {
    this.navCtrl.push("SetupCompanyPage").then(() => {
      this.navCtrl.getActive().onDidDismiss(() => {
        this.ngOnInit();
        this.ionViewDidLoad();
      })
    })
  }

  initOnboarding() {
    this.companySetupBloc.doGetPercentOnBoardingNewCompany();
  }

  tryBeta() {
    let modal = this.modalCtrl.create("TryBetaModalPage", {}, {
      cssClass: "modal-beta",
    });
    modal.present();
  }

  openPolicy() {
    const modal = this.modalCtrl.create('PrivacyPolicyPage', {}, {
      cssClass: 'grd-modal-privacy',
      showBackdrop: true,
      enableBackdropDismiss: false
    });
    modal.onDidDismiss((data) => {
      if (data) {
        console.log(data);
      }
    });

    modal.present();
  }

  /*
  ** CURRENT SURVEY SESSION HAS ENDED **
  
  checkSurvey(): Promise<any> {
    return new Promise((resolve) => {
      const data = localStorage.getItem('surveyAlert');
      if (this.platform.is('cordova')) {
        window.open = cordova.InAppBrowser.open;
      }

      if (!data) {
        this.showSurvey = true;
        localStorage.setItem('surveyAlert', '1');
      } else {
        if (localStorage.getItem('surveyAlert') === '0') {
          this.showSurvey = false;
        }
      }
      resolve(true);
    })
  }

  closeSurvey() {
    this.showSurvey = false;
    localStorage.setItem('surveyAlert', '0');
  }

  openGiveFeedback() {
    window.open(this.surveyLink, '_system');
    this.showSurvey = false;
    localStorage.setItem('surveyAlert', '0');
  }
  */
}



// WEBPACK FOOTER //
// ./src/pages/general/home2/home2.ts